import { Injectable, OnDestroy } from '@angular/core';
import { of, Subject, BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs'
import { finalize, share, tap, shareReplay, takeUntil, catchError, timeout, retry, map, switchMap, take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APPTYPE, WFDriverElement, PERMISSIONSAVAILABLE , BookAppointmentConcept, PromoDetails} from '../app.type';
import * as moment from 'moment-timezone';
import {find as _find} from 'lodash';

import { CookieService } from './cookie.service';
import { InterceptorService } from './interceptor.service';
import { SocketService } from "./socket.service";
import * as AppConstant from '../app.string';
import { CTX, LOGIN_CONTEXT, ALL_COUNTRIES, DEFAULTNORMALCY, AVAILABLE_DIRECTIVES} from '../app.const';

import { environment } from '@env/environment';
import { visitType } from '@type';
import { ToastServiceService } from './toast-service.service';
import { APP_VERSION, PORTAL_SOURCE, REPO_TOKEN, USER_TOKEN } from '@string';
import { Router, ActivatedRoute } from '@angular/router';
import { FeatureFlagsService } from './feature-flags.service';
import { GoogleTagsService } from './google-tags.service';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';
import { PhoneNumberUtil } from "google-libphonenumber";
import { Platform } from '@angular/cdk/platform';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { AppointmentService } from './appointment.service';


@Injectable({
  providedIn: 'root'
})
export class UserService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private updateInfo: any;
  private userInfo: any;
  private userSession: any;
  public userId;
  private repoUrl: string;
  private geoLocation: any;
  private userCredential:any;
  private rtl: any;
  private remaindMe: boolean;
  private isHideFacilityCategory: boolean = false;
  public setLanguage: any;
  public setLabels: any;
  public currentLanguage: string = 'en';
  public currentLocale: string = 'en';
  public isPreCheck: boolean;
  public isSSOLogin: boolean;
  public ssoUserCredential: any;
  public ssoUserObject:any;
  public mapApiSet: boolean;
  public isPatientTask:boolean;
  public loyaltyId: any;
  private localeLabels: any;
  public isTagsEnabled: boolean;
  public GTMContainerId: string;
  private roundOrTruncate: 'R' | 'T' = 'R';
  private roundOfDecimals: number | string = 2;
  public defaultAddress = 'Chennai';
  private countryList: Array<Object> = [];
  private loginContext: any;
  private cache: Map<string, { data: any; timestamp: number; ttl: number }> = new Map();
  private cachedObservable: Map<string, Observable<any>> = new Map();
  private homecareOptions: any = null;
  public appPromoSubject = new BehaviorSubject<any>(null);
  public sectionFocusListener = new BehaviorSubject<any>(null);
  public configLoadedSubject = new BehaviorSubject<boolean>(false);
  public configLoaded: boolean = false;
  public userUpdateSubject = new BehaviorSubject<any>(null);
  public npsRatingSubject = new BehaviorSubject<any>(null);
  public externalInterfaceSubject = new BehaviorSubject<boolean>(false);
  public languageChangeSubject = new BehaviorSubject<string>(this.currentLanguage);
  private taskViewSettings:any = {
    scrollTime: 50,
    minimizeFulfilledSection: true
  }
  private patientRegistrationPayload: any;
  private appType: APPTYPE = 'portal'
  private isExtidLogin = true;

  private googleCaptchaKeyv2: string = null;
  private googleCaptchaKeyv3: string = null;
  private googleCaptchaVersion: 2 | 3;
  private identityRules: any;
  private passwordPolicy: any = {}
  private localeLabelData:any;
  public pxAppSettings: any;
  public resourceMaster: Array<any>;
  public facilityMaster: {actualData: Array<any>, facilityList: Array<any>, facilityProfile: Array<any>, facilityArray?: Array<string>};
  private combinedAppPermissions: any = {}
  private defaultCountryDetail;
  public passwordRegex: any;
  public minPasswordLength: any;
  public maxPasswordLength: any;
  public normalcyInds: any;
  private npsModalDisplayed: boolean = false;
  private timezones: any = {};
  private offsets: any = {};
  public paymentIntervalForReference: any;
  public defaultFacilityForRegistration: any;
  public isFinancialStatusUpdated: boolean;
  public inclinicSelection: any;
  private payerGrpUpdated = new Subject<any>();
  public payerGrpUpdated$: Observable<any>;
  public mandatoryConsent: any;
  public marketingConsent:any;
  private packageClassificationMaster: any = [];
  private directiveGroup: any;
  public allDirectives: any;
  public allPackageConcepts: any;
  public packageClassificationType: any;
  public isBookingSubService: boolean = false;
  public apptRefNum: any;
  public isFromPackage: boolean = false;
  public apptConfirmationDetails: any;
  public dashboardConfig: any;
  private apptReqDermaServices;//'DTPR0800,PKPL000050,PKPL000029,PKPL0409,PKPL0406,DTLS00010,DTPR00011,DTLS07764,DTLS07763,DTPR0101,DTPR0098,DTPR0099,DTPR0105,DTPR0106,DTPR0104,DTPR0108,DTPR0096,DTPR0100,DTPR0103,DTPR0097,DTPR0107,DTPR0064,DTPR0109,DTPR0059,DTPR0060,DTPR0038,DTPR0039,DTPR0040,DTPR0113,DTPR0035,DTPR0036,DTPR0037,DTPR0110,DTPR0148,PKPL000066,DTPR0823,DTPR0825,DTPR0824,DTPR0194,DTPR0212,DTPR0121,DTPR0043,DTPR0044,DTPR0063,DTPR0045,PKPL000051,PKPL0407,DTPR07769,DTPR0111,DTPR0112,DTPR0147,DTPR0150,DTPR0838,DTPR2020,PKPL0411,DTPR0363,PKPL000065,DSPR0003,DSPR0002,DSPR0006,PKPL0408,PKPL0412,DSPR0001,DSPR0008,DSPR0007,PKPL000064'
  private apptReqConsultServices;
  public restrictApprovalCode:any;
  public restrictApprovalStatusCode: any;
  public encounterList: any;
  public doctorRecServiceList: any;
  public doctorRecDtls: any;
  private directivesSplitIntosubdirectiveCategory: any;
  constructor(private cookie: CookieService, private interceptor: InterceptorService, public socket: SocketService, private http: HttpClient, private toast: ToastServiceService, private router: Router, private route: ActivatedRoute, private featureFlagsService: FeatureFlagsService, private gtmService:GoogleTagsService, public platform: Platform) {
    this.updateInfo = new Array<any>();
    this.userInfo = new Array<any>();
    this.userSession = new Array<any>();
    this.countryList = new Array<Object>();
    this.payerGrpUpdated$ = this.payerGrpUpdated.asObservable();
    this.mapApiSet = false;
    if(window.location['href'].includes(`/${AppConstant.ROUTE_VACCINE}`) || window.location['href'].includes(`/${AppConstant.ROUTE_TASK}/`) || window.location['href'].includes(`/${AppConstant.ROUTE_VIEW}/`))
      this.isPatientTask = true;
    this.initializeService();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.clearCache();
  }

  private initializeService(): void {
    this.retriveStorage();
    this.setTaskViewSettings(null);
    
    const appType: APPTYPE = this.cookie.getStorage('APPTYPE') as APPTYPE;
    if (appType) {
      this.setAppType(appType);
    }

    this.initializeDefaultCountry();
  }

  private initializeDefaultCountry(): void {
    const defaultCountryDetail = ALL_COUNTRIES.filter(c => 
      c[2] == environment.COUNTRY_CODE || `+${c[2]}` == environment.COUNTRY_CODE
    );
    
    if (defaultCountryDetail.length > 1 && environment['COUNTRYID']) {
      this.defaultCountryDetail = defaultCountryDetail.find(c => c[1] == environment['COUNTRYID']);
    } else {
      this.defaultCountryDetail = defaultCountryDetail[0];
    }
  }

  public getDefaultCountryDetailForSignIn() {
    return this.defaultCountryDetail;
  }

  //NOTE
  // 1. GET SET METHODS
  // 2. GET METHODS
  // 3. API SERVICES

  // GET SET METHODS

  private retriveStorage() {
    if (localStorage.getItem(AppConstant.REMAIND_ME)) {
      this.remaindMe = localStorage.getItem(AppConstant.REMAIND_ME) === 'true';
      this.cookie.setRemaindMe(this.remaindMe);
    }
    this.restoreLanguagePreference();
    let default_settings = [...AppConstant.DEFAULT_STORAGE_SETTINGS];
    default_settings.forEach(setting => {
      if (setting === 'USER_LANGUAGE') {
        return;
      }
      let value = this.getLocalStorage(AppConstant[setting]);
      if (!value) {
        value = this.getStorage(AppConstant[setting]);
      }
      if (value) {
        this.setStorage(AppConstant[setting], value);
        switch (AppConstant[setting]) {
          case AppConstant.USER_OBJECT:
            this.setUserInfo(JSON.parse(value), this.remaindMe, false, true);
            break;
        }
      }
    });
    this.getGeoLocation().subscribe();
  }

  private restoreLanguagePreference(): void {
    const raw = sessionStorage.getItem(AppConstant.USER_LANGUAGE)
      || localStorage.getItem(AppConstant.USER_LANGUAGE);
    if (!raw) {
      return;
    }
    try {
      const lang = JSON.parse(raw);
      this.setCurrentLanguage(lang);
      this.getUpdateInfo('configuration').subscribe(() => {
        this.refreshLocaleLabels();
      });
    } catch (e) {
      console.error('Failed to restore language preference', e);
    }
  }

  private hasStoredLanguagePreference(): boolean {
    return !!(sessionStorage.getItem(AppConstant.USER_LANGUAGE)
      || localStorage.getItem(AppConstant.USER_LANGUAGE));
  }

  public setPackages(){
    // Use sync access since data should already be loaded
    const data = this.getUpdateInfoSync('directives');
    if (data && data.userDefined) {
      data.userDefined.find(def => {
        if (def.directiveGroup == 'HOSPSERV') {
          this.setStorage(AppConstant.HEALTHPKG_LIST, JSON.stringify(def));
        }
      })
      let result = {};
      if (data && data.userDefined) {
        result = _.groupBy(data.userDefined, 'directiveGroup')
      }
      const directiveGroup: any = {}
      const groupTypes = {
        ECONSULT: 'ECONSULT',
        HOSPSERV: 'HEALTHPACKAGES',
        FAQ: 'FAQ',
        FEEDBACK: 'FEEDBACK',
        INSURANCE_TC: 'TERMSCONDITIONS',
        GUIDELINES: 'GUIDELINES',
        VIDEOCONSULTTC: 'VIDCONSTC'
      }
      Object.keys(result).forEach(key => {
        if (groupTypes[key])
          directiveGroup[groupTypes[key]] = result[key];
      })
      this.directiveGroup = directiveGroup;
      this.mapPackageDirectives(data)
    }
  }

    private mapPackageDirectives(directives) {
    console.info('directives', directives);
    let allDirectives = _.cloneDeep(directives.userDefined);
    this.allDirectives = allDirectives.map(directive => {
      let parentDirective = _.cloneDeep(directive)
      delete parentDirective.concepts;
      directive.concepts = (directive?.concepts || []).map(concept => {
        concept._directiveRef = parentDirective;
        concept._displayPriority = concept?.packageDtls?.displayPriority || 5;
        concept._modeOfServices = ['CLINIC'];
        if (concept?.packageDtls?.modeOfServices?.includes('HC')) { 
          concept._modeOfServices.push('HOMECARE');
          concept.homecareInfo = {
            directiveCode: directive.code,
            conceptCode: concept.code
          }
        }
        return concept;
      })
      return directive;
    })

    const packageDirectives = _.cloneDeep(this.allDirectives).map(directive => {
      directive.concepts = directive.concepts.filter(concept => concept?.packageDtls?.isPackageApplicable == 'Y')
      return directive;
    }).filter(directive => directive?.isPackageApplicable == 'Y' && directive.concepts.length > 0)
    console.info('packageDirectives', packageDirectives);
    this.directiveGroup['HEALTHPACKAGES'] = packageDirectives;
    this.allPackageConcepts = packageDirectives.map(p => p.concepts || []).flat();
  }

  public getAllDirectives() {
    return this.allDirectives;
  }
  
  public getAllPackageConcepts() {
    return this.allPackageConcepts;
  }

  public getDirectiveByDirectiveGroup(groupCode: AVAILABLE_DIRECTIVES) {

    if (groupCode && this.directiveGroup[groupCode])
      return this.directiveGroup[groupCode]
    else
      return null
  }

  public hideFacilityCategory() {
    return this.isHideFacilityCategory;
  }
  public setStorage(key, value) {
    this.cookie.set(key, value);
  }


  public findConcept(allPackages, key) {
    // console.log('findConcept', allPackages, 'key', key)
    let directiveCode = key?.directiveCode || key?.packageCode;
    let conceptCode = key?.conceptCode || key?.serviceCode;
    let directive = allPackages.find(dir => dir.code === directiveCode)
    if (!directive) return false;
    let concept = directive?.concepts.find(con => con.code === conceptCode)
    if (!concept) return false;
    return concept;
  }
  
  /**
   * Store sensitive tokens only in sessionStorage (never localStorage)
   * Used for USER_TOKEN, USER_OBJECT, and REPO_TOKEN
   */
  public setSessionOnlyStorage(key, value) {
    sessionStorage.setItem(key, value);
    console.debug(`Stored ${key} in sessionStorage only (not localStorage)`);
  }
  
  public clearStorage() {
    this.cookie.clearStorage();
  }
  public getStorage(key) {
    return this.cookie.getStorage(key);
  }
  public getLocalStorage(key) {
    return this.cookie.getLocalStorage(key);
  }
  public setLoginInfo(data: any, remaindme: boolean, isOpenSSOLogin:boolean = false) {
    this.setUserInfo(data, remaindme, isOpenSSOLogin);
    //Added function to fetch factilities and practitioner based on resourceListing API
    if (this.cookie.getStorage(AppConstant.USER_TOKEN))
      this.getPatientFacilities(true);
    let time = this.getMoment().add(environment.TOKEN_EXPIRY_HOURS, 'hours').valueOf();
    this.setStorage(AppConstant.EXPIRY_TIME, time);
    const obj = {
      event_source: 'Website',
      language: this.currentLanguage,
      'user_id': data.personId
    }
    this.gtmService.pushGTMEvent(null, 'global_variables', obj)
    if (data && data.patientRegistration && data.patientRegistration.enable) {
      this.patientRegistrationPayload = data.patientRegistration
      return true;
    } else {
      this.patientRegistrationPayload = null;
    }
    return false
  }
  public updateUserInfo(obj) {
    let data = JSON.parse(this.getStorage(AppConstant.USER_OBJECT));
    if (!data)
      data = {};
    if (!this.userInfo.personDetails) {
      this.userInfo.personDetails = {}
    }
    Object.keys(obj).forEach(b => {
      switch (b) {
        case 'email':
          this.userInfo.personDetails['email'] = obj['email'];
          data.emailId = obj['email']
          break;
        case 'personName':
          this.userInfo.personDetails['personName'] = obj['personName'];
          data.name = obj['personName']
          break;
        case 'mobile':
          this.userInfo.personDetails['mobile'] = obj['mobile'];
          data.mobile = obj['mobile'];
          break;
        case 'countryCode':
          this.userInfo.personDetails['countryCode'] = obj['countryCode'];
          data.countryCode = obj['countryCode'];
          break;
        case 'photoUrl':
          this.userInfo.personDetails['photoUrl'] = obj['photoUrl'];
          data.photoUrl = obj['photoUrl'];
          break;
      }
    })
    this.setSessionOnlyStorage(AppConstant.USER_OBJECT, JSON.stringify(data));
  }
  public setUserInfo(userData: any, remaindme: boolean, isOpenSSOLogin: boolean = false, refresh: boolean = false) {
    if (!userData) {
      return;
    }

    // Set remember me preference
    this.remaindMe = remaindme;
    this.cookie.setRemaindMe(this.remaindMe);

    // Update SSO login flag
    if (isOpenSSOLogin) {
      userData.isOpenSSOLogin = isOpenSSOLogin;
    }

    // Set session data
    this.userSession = userData;
    this.userCredential = userData.pin;

    // Create person details object
    const personDetails = {
      personId: userData.personId,
      personName: userData.name,
      photoUrl: userData.photoUrl,
      email: userData.emailId,
      mobile: userData.mobile,
      countryCode: userData.countryCode,
      contextPersonName: userData.contextPersonName,
      isHof: userData.isHof,
      externalId: userData.natid
    };

    // Handle user credentials and token storage
    const credentials = {
      token: userData?.credentials?.token
    };

    this._handleTokenStorage(
      userData.credentials?.token,
      AppConstant.USER_TOKEN,
      USER_TOKEN,
      refresh
    );

    // Handle repository access
    let repoDetails = null;
    const repositoryAccess = userData?.credentials?.repositoryAccess;
    if (repositoryAccess?.success) {
      repoDetails = {
        token: repositoryAccess.token,
        url: repositoryAccess.url,
      };

      this._handleTokenStorage(
        repositoryAccess.token,
        AppConstant.REPO_TOKEN,
        REPO_TOKEN,
        refresh
      );

      this.repoUrl = repositoryAccess.url;
    }

    // Set user info object
    this.userInfo = {
      personDetails,
      credentials,
      repoDetails,
      linkedPatients: userData.linkedPatients || null,
      isOpenSSOLogin: userData.isOpenSSOLogin
    };

    // Store user object in session
    this.setSessionOnlyStorage(AppConstant.USER_OBJECT, JSON.stringify(userData));
    
    // Handle Google Maps API key configuration
    this._configureGoogleMapsApi();

    // Set HOF feature flag
    this.featureFlagsService.setHOF(personDetails.isHof === 'Y');
  }

  /**
   * Helper method to handle token storage operations
   * @param token - The token to store
   * @param constantKey - The constant key for session storage
   * @param fallbackKey - The fallback key for local storage
   * @param refresh - Whether to refresh from local storage if token is not available
   */
  private _handleTokenStorage(token: string, constantKey: string, fallbackKey: string, refresh: boolean): void {
    if (token) {
      this.setSessionOnlyStorage(constantKey, token);
    } else if (refresh && localStorage) {
      const storedToken = this.getLocalStorage(fallbackKey);
      if (storedToken) {
        this.setSessionOnlyStorage(fallbackKey, storedToken);
      }
    }
  }

  /**
   * Helper method to configure Google Maps API
   */
  private _configureGoogleMapsApi(): void {
    const configData = this.getUpdateInfoSync('configuration');
    const googleMapApiKey = configData?.profile?.googleMapApiKey;
    if (googleMapApiKey) {
      this.setGoogleApiKey(googleMapApiKey);
    }
  }

  private checkMapsKey() {
    if (this.configLoaded) {
      this.setMapsKey();
    } else {
      this.configLoadedSubject.subscribe(_ => {
        this.setMapsKey();
      })
    }
  }

  private setMapsKey() {
    const data = this.updateInfo['configuration']
    if (data['profile'] && data['profile']['googleMapApiKey']) {
      let key = data['profile']['googleMapApiKey'];
      this.setGoogleApiKey(key);
    }
    this.setTruncateInfo();
  }


  public setGoogleApiKey(key) {
    if (key && !this.mapApiSet) {
        try {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://maps.googleapis.com/maps/api/js?v=3&key=${key}&libraries=places`; //& needed
            document.body.appendChild(script);
            this.mapApiSet = true;
        } catch (err) {
            this.mapApiSet = false;
        }
    } else {
        console.log('MAP key not configured');
    }
}

  public setSSOCredentials(data, remaindme?: boolean, updateRememberMe = true) {
    if (updateRememberMe && typeof remaindme === 'boolean') {
      this.remaindMe = remaindme;
      this.cookie.setRemaindMe(this.remaindMe);
    }
    this.setSessionOnlyStorage(AppConstant.ACCESS_TOKEN, data.ssocredentials.access_token);
    if (data.ssocredentials.refresh_token) {
      this.setStorage('SSO_REFRESH_TOKEN', data.ssocredentials.refresh_token);
    }
    this.setStorage(AppConstant.SSO_CREDENTIAL, JSON.stringify(data.ssocredentials));
    this.setStorage(AppConstant.SSO_USER_OBJECT, JSON.stringify(data.userInfo));
    this.ssoUserObject = data.userInfo;
    this.loyaltyId = data.userInfo.username;
    if (updateRememberMe) {
      // Explicit login — SSO profile language overrides any stale stored preference
      this.applyLanguageFromSSOUser(data.userInfo, false, true);
    } else if (!this.hasStoredLanguagePreference()) {
      // Silent refresh — only apply SSO language when user has not chosen one
      this.applyLanguageFromSSOUser(data.userInfo, false);
    }
  }

  public setSSOObjectOnUpdate(data) {
    // this.remaindMe = remaindme;
    this.cookie.setRemaindMe(this.remaindMe);
    this.setStorage(AppConstant.SSO_USER_OBJECT, JSON.stringify(data));
    this.ssoUserObject = data;
    this.loyaltyId = data.username;
    if (!this.hasStoredLanguagePreference()) {
      this.applyLanguageFromSSOUser(data, true);
    }
  }

  private getSSOLanguageCode(ssoUser: any): string | null {
    if (!ssoUser) {
      return null;
    }
    const lang = ssoUser.language || ssoUser.Language;
    return lang ? String(lang).toLowerCase() : null;
  }

  /**
   * Sync portal language from SSO user profile.
   * @param reloadOnChange when true, reloads the page (profile updates); false during login so navigation is not interrupted
   * @param force when true, applies SSO language even if a stored preference exists (used on login)
   */
  public applyLanguageFromSSOUser(ssoUser?: any, reloadOnChange = false, force = false): void {
    if (!force && !reloadOnChange && this.hasStoredLanguagePreference()) {
      return;
    }
    const langCode = this.getSSOLanguageCode(ssoUser || this.getSSOUserdetail());
    if (!langCode) {
      return;
    }
    // Wait for configuration to load — getLanguages() can cache an empty list on cold SSO redirect
    this.getUpdateInfo('configuration').subscribe(config => {
      const languageList = config?.languages;
      if (!languageList?.length) {
        return;
      }
      this.applyLanguagePreference(languageList, langCode, reloadOnChange, force);
    });
  }

  private applyLanguagePreference(languageList: any[], selectedLangCode: string, reloadOnChange: boolean, force = false): void {
    const lang = languageList.find(item => item.localeCode == selectedLangCode);
    if (!lang) {
      return;
    }
    this.changeLanguage(lang, reloadOnChange, force);
  }

  /**
   * Apply a language selection: direction, persisted preference, and label refresh.
   * @param reload when true, reloads the page after persisting (legacy setDirection behaviour)
   * @param force when true, refreshes labels/preference even if locale is already active
   */
  public changeLanguage(lang: any, reload = false, force = false): void {
    if (!lang) {
      return;
    }
    if (lang.localeCode === this.currentLanguage) {
      if (!force) {
        return;
      }
      this.cookie.setRemaindMe(true);
      this.persistLanguagePreference(lang);
      if (reload) {
        location.reload();
        return;
      }
      this.refreshLocaleLabels();
      return;
    }
    this.cookie.setRemaindMe(true);
    this.setCurrentLanguage(lang);
    this.persistLanguagePreference(lang);
    if (reload) {
      location.reload();
      return;
    }
    this.refreshLocaleLabels();
  }

  private refreshLocaleLabels(): void {
    this.getLabels().subscribe(labels => {
      if (labels) {
        this.setLocaleLabels(labels);
        this.languageChangeSubject.next(this.currentLanguage);
      }
    });
  }

  private persistLanguagePreference(lang: any): void {
    const serialized = JSON.stringify(lang);
    localStorage.setItem(AppConstant.USER_LANGUAGE, serialized);
    sessionStorage.setItem(AppConstant.USER_LANGUAGE, serialized);
  }

  public setAccessToken(token) {
    this.setSessionOnlyStorage(AppConstant.ACCESS_TOKEN, token);
  }

  public setAccessTokenOnRefresh(token): Observable<any>{
    return new Observable(observer => {
      this.setSessionOnlyStorage(AppConstant.ACCESS_TOKEN, token);
      observer.next('SUCCESS');
    })
  }

  public setMandatoryConsent(data) {
    this.mandatoryConsent = data;
  }

  public setMarketingConsent(data) {
    this.marketingConsent = data;
  }

  public setInclinicSelection(data) {
    this.inclinicSelection = data;
  }

  public getInclinicSelection() {
    return this.inclinicSelection;
  }

  public clearInclinicSelection() {
    this.inclinicSelection = null;
  }

  public getSSOCredentials(): Observable<any>{
    return Observable.create(observer => {
      this.ssoUserCredential = JSON.parse(sessionStorage.getItem(AppConstant.SSO_CREDENTIAL));
      observer.next(this.ssoUserCredential);
    })
  }

  public getSSOUserObject(): Observable<any>{
    return Observable.create(observer => {
      let userObj = JSON.parse(sessionStorage.getItem(AppConstant.SSO_USER_OBJECT));
      observer.next(userObj);
    })
  }

  public getMandatoryConsent() {
    return this.mandatoryConsent;
  }

  public getMarketingConsent() {
   return this.marketingConsent;
  }

  public getloyaltyId() {
    if(this.loyaltyId)
      return this.loyaltyId
    let userObj = JSON.parse(sessionStorage.getItem(AppConstant.SSO_USER_OBJECT));
    this.loyaltyId = userObj.username
    return userObj.username
  }

  public getSSOUserdetail(){
    this.ssoUserObject = JSON.parse(sessionStorage.getItem(AppConstant.SSO_USER_OBJECT));
    return this.ssoUserObject;
  }

  public getCaptchaKey(version) {
    if (!version) version = this.googleCaptchaVersion;
    return version == 2 ? this.googleCaptchaKeyv2 : this.googleCaptchaKeyv3;
  }
  public getCaptchaVersion() {
    return this.googleCaptchaVersion;
  }

  private setCaptchaKey(keyv3 , version:2|3 = 3) {
    this.googleCaptchaKeyv3 = keyv3;
    this.googleCaptchaVersion = version;
  }

  public setDirection(data) {
    this.changeLanguage(data, true);
  }

  public setDefaultFacilityForRegistration(facilityId) {
    this.defaultFacilityForRegistration = facilityId;
  }

  public getDefaultFacilityForRegistration() {
    return this.defaultFacilityForRegistration;
  }

  public getCurrency() {
    let localeCurrency;
    if(this.localeLabelData){
      localeCurrency=this.localeLabelData['localeCurrency'] ?  this.localeLabelData['localeCurrency'] : this.updateInfo['configuration']['currency'];
    }else{
      this.getLabels().subscribe(data => {
        this.localeLabelData=data;
        localeCurrency=this.localeLabelData['localeCurrency'] ?  this.localeLabelData['localeCurrency'] : this.updateInfo['configuration']['currency'];
      });
    }

    return localeCurrency;
  }

  public getAppDirection() {
    return this.rtl == 'true' ? 'rtl' : 'ltr';
  }
  public setCurrentLanguage(data) {
    console.trace('setCurrentLanguage', data)
    if(data){
      this.currentLanguage = data.localeCode;
      if(data.otherOptions && data.otherOptions != null ){
        this.currentLocale = data.otherOptions.equivalentMomentCode ? data.otherOptions.equivalentMomentCode : data.localeCode;
      } else {
        this.currentLocale = data.localeCode;
      }
      console.log("get rtl", this.currentLocale)
      this.rtl = data.rtl;
      if (data.rtl === 'true')
        document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
      else
        document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    }
    moment.locale('en');
  }

  public getDirection(): Observable<any> {
    return of(this.rtl);
  }

  public getUserInfo(key?: string): Observable<any> {
    return of(key ? (this.userInfo?.[key] || null) : this.userInfo);
  }
  public removeUserInfo() {
    this.userInfo = null;
    sessionStorage.removeItem(AppConstant.USER_OBJECT);
  }

  // Optimized caching methods
  private setCache(key: string, data: any, ttlMinutes: number = 5): void {
    const ttl = ttlMinutes * 60 * 1000; // Convert to milliseconds
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      ttl
    });
  }

  private getCache(key: string): any {
    const cached = this.cache.get(key);
    if (!cached) return null;

    const now = Date.now();
    if (now - cached.timestamp > cached.ttl) {
      this.cache.delete(key);
      return null;
    }

    return cached.data;
  }

  private clearCache(): void {
    this.cache.clear();
    this.cachedObservable.clear();
  }

  private getCachedObservable<T>(key: string, provider: () => Observable<T>, ttlMinutes: number = 5): Observable<T> {
    // Check memory cache first
    const cached = this.getCache(key);
    if (cached) {
      return of(cached);
    }

    // Check if observable is in flight
    if (this.cachedObservable.has(key)) {
      return this.cachedObservable.get(key);
    }

    // Create new observable
    const observable = provider().pipe(
      tap(data => {
        this.setCache(key, data, ttlMinutes);
        this.cachedObservable.delete(key);
      }),
      shareReplay(1),
      takeUntil(this.destroy$)
    );

    this.cachedObservable.set(key, observable);
    return observable;
  }
  public setUpdateInfo(data: any): Observable<any> {
    return of(null).pipe(map(() => {
      const tempContentResponse = JSON.parse(localStorage.getItem(AppConstant.CONTENT_RESPONSE) || '{}');

      if (data) {
        this.updateInfo = data.reduce((obj, item) => {
          if (item.body)
            return { ...obj, [item.header.type]: item.body };
          else if (tempContentResponse)
            return { ...obj, [item.header.type]: tempContentResponse[item.header.type] }
          else
            return obj;
        }, {});

        let contentHeaders = data.reduce((header, d) => {
          if (d.header.type != 'fbcredentials')
            header.push(d.header);
          return header;
        }, []);

        if (environment['RETRIEVE_LOCALSTORAGE']) {
          localStorage.setItem(AppConstant.CONTENT_HEADER, JSON.stringify(contentHeaders));
        }
      } else {
        this.updateInfo = tempContentResponse;
      }

      if (environment['RETRIEVE_LOCALSTORAGE']) {
        localStorage.setItem(AppConstant.CONTENT_RESPONSE, JSON.stringify(this.updateInfo));
      } else {
        localStorage.removeItem(AppConstant.CONTENT_HEADER);
        localStorage.removeItem(AppConstant.CONTENT_RESPONSE);
      }

      console.log('updateInfo ==>>', this.updateInfo);

      if (this.updateInfo['configuration'] && this.updateInfo['configuration']['pxAppSettings'] && this.updateInfo['configuration']['pxAppSettings']['enableDataDogIntegration'] == 'Y') {
        this.initDataDog(this.updateInfo['configuration']['pxAppSettings']['dataDogConfig'], this.updateInfo['configuration']['pxAppSettings']['dataDogSettings']);
      }

      if (this.updateInfo?.['fbcredentials']?.['repoUrl']) {
        this.setRepoUrl(this.updateInfo['fbcredentials']['repoUrl']);
      }

      if (this.updateInfo && this.updateInfo['facilityServices'] && this.updateInfo['facilityServices']['facilities']) {
        this.updateInfo['facilityServices']['facilities'] = this.updateInfo['facilityServices']['facilities'].map(fac => {
          fac.specialities = fac.specialities.map(spec => {
            let pracList = fac.practitioners.filter(prac => {
              return prac.specialityId === spec.specialityId;
            });
            let videoPrac = fac.practitioners.filter(prac => {
              return prac.specialityId == spec.specialityId && (prac.schedulerControls['consultType'] == 'HOSPVIDEO' || prac.schedulerControls['consultType'] == 'VIDEO');
            })
            let hospPrac = fac.practitioners.filter(prac => {
              return prac.specialityId == spec.specialityId && (prac.schedulerControls['consultType'] == 'HOSPVIDEO' || prac.schedulerControls['consultType'] != 'VIDEO');
            })
            return { ...spec, pracList: pracList, pracCount: pracList.length, VIDEO: videoPrac, VIDEOCOUNT: videoPrac.length, HOSPITAL: hospPrac, HOSPITALCOUNT: hospPrac.length }
          })
          return fac;
        });

        if (this.cookie.getStorage(AppConstant.USER_TOKEN))
          this.getPatientFacilities(true);

        this.featureFlagsService.initialize({ ...this.updateInfo })

        // if (this.updateInfo['configuration'] && this.updateInfo['configuration']['profile']['googlTagsManager']) {
        //   this.setGTMTagConfig(this.updateInfo['configuration']['profile']['googlTagsManager']);
        // }
        if (this.updateInfo['configuration'] && this.updateInfo['configuration']['homecare']) {
          this.homecareOptions = this.updateInfo['configuration']['homecare'];
        }
        this.presentAppPromotion(this.updateInfo);
        if (this.updateInfo['configuration'] && this.updateInfo['configuration']['profile']['googleCaptchaKey']) {
          this.setCaptchaKey(this.updateInfo['configuration']['profile']['googleCaptchaKey'], 3);
        }
        if (this.updateInfo['configuration'] && this.updateInfo['configuration']['identityRules'] && this.updateInfo['configuration']['identityRules']['passwordpolicy']) {
          this.passwordPolicy = this.updateInfo['configuration']['identityRules']['pxpasswordpolicy']
          console.log(this.passwordPolicy)
        }
        if (this.updateInfo['configuration'] && this.updateInfo['configuration']['identityRules'] && this.updateInfo['configuration']['identityRules']) {
          this.setIdentiyRules(this.updateInfo['configuration']['identityRules']);
          this.passwordRegex = this.updateInfo['configuration']['identityRules'].pxAppPasswordRegex
          this.minPasswordLength = this.updateInfo['configuration']['identityRules'].minPasswordLength
          this.maxPasswordLength = this.updateInfo['configuration']['identityRules'].maxPasswordLength
        }
        if (this.updateInfo['configuration'] && this.updateInfo['configuration']['pxAppSettings']) {
          this.pxAppSettings = this.updateInfo['configuration']['pxAppSettings']
          this.updatePxAppPermissions(this.pxAppSettings);
        }
        console.log('integrationSettings', this.updateInfo.configuration.integrationSettings)
        if (this.updateInfo?.configuration?.integrationSettings?.defaultTimezone) {
          this.setDefaultTimezone(this.updateInfo.configuration.integrationSettings.defaultTimezone);
        }
        if (this.updateInfo['configuration'] && this.updateInfo['configuration']['identityRules'] && this.updateInfo['configuration']['identityRules'] && this.updateInfo['configuration'] && this.updateInfo['configuration']['identityRules'] && this.updateInfo['configuration']['identityRules']['newRegistration'] && this.updateInfo['configuration']['identityRules']['newRegistration']['defaultFacilityForRegistration']) {
          this.setDefaultFacilityForRegistration(this.updateInfo['configuration']['identityRules']['newRegistration']['defaultFacilityForRegistration']);
        }
        if (this.updateInfo?.facilities?.facilities) {
          this.setFacilitiesTimezone(this.updateInfo.facilities.facilities)
        }
        if(this.updateInfo?.dashboard) {
          this.setDashboardConfig(this.updateInfo?.dashboard)
        }
        return null;
      }
    }));
  }

  public getHomecareOptions() {
    //Mock JSON for homecare service
    // this.homecareOptions = HOME_CARE_SERVICES
    return this.homecareOptions;
  }
  public getUpdateInfo(key?: string): Observable<any> {
    // If configuration is already loaded and updateInfo exists
    if (this.configLoaded && this.updateInfo) {
      // If no key, return entire updateInfo
      if (!key) {
        return of(this.updateInfo);
      }

      // If updateInfo has the requested key
      if (this.updateInfo[key]) {
        if (key === 'facilities' || key === 'facilityServices') {
          const val = this.getAttributeForListingType(key, true);
          return of(val);
        }
        return of(this.updateInfo[key]);
      }

      // If key is '*', return entire updateInfo
      if (key === '*') {
        return of(this.updateInfo);
      }

      // Key doesn't exist in updateInfo
      return of(null);
    }

    // If updateInfo doesn't exist or config not loaded, fetch it only once
    return this.updateCheck().pipe(
      map(() => {
        this.checkMapsKey()
        return key === '*' ? this.updateInfo : (this.updateInfo && this.updateInfo[key]) || null;
      }),
      shareReplay(1)
    );
  }

  /**
   * Get update info synchronously (non-observable) - returns cached data only
   * This should only be called after the initial getUpdateInfo() has completed
   */
  public getUpdateInfoSync(key?: string): any {
    if (!this.configLoaded || !this.updateInfo) {
      console.warn('getUpdateInfoSync called before updateInfo is loaded. Use getUpdateInfo() first.');
      return null;
    }

    // If no key, return entire updateInfo
    if (!key) {
      return this.updateInfo;
    }

    // If updateInfo has the requested key
    if (this.updateInfo[key]) {
      if (key === 'facilities' || key === 'facilityServices') {
        return this.getAttributeForListingType(key, true);
      }
      return this.updateInfo[key];
    }

    // If key is '*', return entire updateInfo
    if (key === '*') {
      return this.updateInfo;
    }

    // Key doesn't exist in updateInfo
    return null;
  }

  public refreshSession(): Observable<any> {
    const refresh = JSON.parse(sessionStorage.getItem(AppConstant.SSO_CREDENTIAL) || '{}');
    
    if (!refresh.refresh_token) {
      return of(null);
    }

    const payload = {
      refresh_token: refresh.refresh_token,
      source: PORTAL_SOURCE
    };

    return this.http.post(`${environment['API_URL']}${AppConstant.API_EXTERNAL_AUTH}/refreshSession`, payload, { reportProgress: true }).pipe(
      timeout(15000),
      retry(2),
      catchError(error => {
        console.error('Refresh session failed:', error);
        return of(this.getErrorMessage(error));
      })
    );
  }
  public getDefaultFacility() {
    return this.updateInfo['facilityServices']['facilities'][0]['facilityId'];
  }
  public getFacility() {
    let facilities = this.getAttributeForListingType('specialities', true)
    return facilities
    // return this.updateInfo['facilityServices']['facilities'];
  }
  //GET METHODS
  public getLanguages(): Observable<any> {
    return this.getCachedObservable('languages', () => {
      return this.getConfigurationInfo.pipe(
        map(data => data['languages'] || [])
      );
    }, 10); // Cache for 10 minutes
  }

  public getExternalInterface(): Observable<boolean> {
    // Update the subject with fresh data from configuration
    this.getConfigurationInfo.pipe(
      map(data => data['features']?.externalInterface || false)
    ).subscribe(externalInterface => {
      this.externalInterfaceSubject.next(externalInterface);
    });
    
    return this.externalInterfaceSubject.asObservable();
  }
  public getLabels(checkCurLang: boolean = false): Observable<any> {
    return Observable.create(observer => {
      if (!this.configLoaded) {
        this.configLoadedSubject.subscribe(_ => {
          const returnData = this.checkLabels();
          observer.next(returnData);
        })
      } else {
        const returnData = this.checkLabels();
        observer.next(returnData);
      }
    });
  }

  private checkLabels() {
    const localization = this.updateInfo?.['labels']?.localization;
    if (!localization?.length) {
      return null;
    }
    const localized = localization.find(item => item.locale === this.currentLanguage);
    return localized?.labels || localization[0]?.labels;
  }

  public getLabelsBasedOnLang(key, lang) {
    let langLabels = this.updateInfo['labels'].localization;
    let langObj = langLabels.find(lab => lab.locale == lang);
    if (!langObj) langObj = langLabels[0];
    return langObj.labels[key];
  }

  public getErrorMessage(error) {
    if (typeof error === 'string')
      return error;
    if (error && error.error && error.error.error && error.error.error.message)
      return error.error.error.message;
    return 'Something went wrong';
  }

  public getUserId() {
    this.userId = this.userInfo?.personDetails?.personId
    return Observable.create(observer => {
      observer.next(this.userId);
    })
  }
  public getPersonId() {
    return this.userInfo && this.userInfo.personDetails ?this.userInfo.personDetails.personId:'';
  }
  public getIsOpenSSOLogin() {
    return this.userInfo && this.userInfo.isOpenSSOLogin ? this.userInfo.isOpenSSOLogin: false;
  }
  public getPersonMobile() {
    return this.userInfo && this.userInfo.personDetails ? this.userInfo.personDetails.mobile: '';
  }
  public getPersonName() {
    return this.userInfo && this.userInfo.personDetails ?this.userInfo.personDetails.personName:'';
  }
  public getPersonEmail() {
    return this.userInfo && this.userInfo.personDetails ?this.userInfo.personDetails.email:'';
  }
  public getPersonCountryCode() {
    return this.userInfo && this.userInfo.personDetails ?this.userInfo.personDetails.countryCode:'';
  }
  public getPersonNationalId() {
    return this.userInfo.personDetails.externalId;
  }

  public getUserDetail() {
    let userDetail = this.userInfo.personDetails
    return Observable.create(observer => {
      observer.next(userDetail);
    })
  }

  public getUserCredential(){
    let userDetail =
    {
      personDetails: this.userInfo.personDetails,
      credential: this.userCredential
    }
    return Observable.create(observer => {
      observer.next(userDetail);
    })
  }

  public getRepoUrl() {
    // const proxyurl = 'https://cors-anywhere.herokuapp.com/';
    // this.repoUrl = proxyurl+this.repoUrl
    return this.repoUrl;
  }

  public setAppointmentRefNum(data) {
    this.apptRefNum = data;
  }

  public getAppointmentRefNum() {
    return this.apptRefNum;
  }

  public setIsFromPackage(data) {
    this.isFromPackage = data;
  }

  public getIsFromPackage() {
    return this.isFromPackage;
  }

  public setApptConfirmationDetails(data) {
    this.apptConfirmationDetails = data;
  }

  public getApptConfirmationDetails() {
    return this.apptConfirmationDetails;
  }


  public setRepoUrl(url) {
    this.repoUrl = url;
  }

  public setLinkedPatient(data) {
    this.userInfo.linkedPatients = data.linkedPatients;
    this.userSession.linkedPatients = data.linkedPatients;
    this.updateUserSession();
  }

  public setLinkedPatientFromUser(data) {
    this.userInfo.linkedPatients = data;
    this.userSession.linkedPatients = data;
    this.updateUserSession();
  }

  public canDisableRegister(): boolean {
    const canHideRegister = !!this.canViewOption('CANHIDEREGISTER');
    const linkedPatients = this.userInfo?.linkedPatients;
    const maxLinkedCount = this.getMaxLinkedPatientCount();
    if (!canHideRegister || !Array.isArray(linkedPatients)) {
      return false;
    }

    if (maxLinkedCount <= 0) {
      return false;
    }

    return linkedPatients.length >= maxLinkedCount;
  }

  public getMaxLinkedPatientCount(): number {
    const identityRuleMax = Number(this.identityRules?.registration?.max);
    if (Number.isFinite(identityRuleMax) && identityRuleMax > 0) {
      return identityRuleMax;
    }

    const configuredMax = Number(this.canViewOption('LINKEDPERSONMAXCOUNT'));
    return Number.isFinite(configuredMax) && configuredMax > 0 ? configuredMax : 0;
  }

  public setIdentiyRules(rules) {
    this.identityRules = rules;
  }

  public updateUserSession() {
    this.setSessionOnlyStorage(AppConstant.USER_OBJECT, JSON.stringify(this.userSession));
  }

  public findFacility(facilityId) {
    if(this.isPatientTask) return null;
    let facilities = this.getAttributeForListingType('facList', true)
    let fac = facilities.find(facility => {
      return facility.facilityId == facilityId;
    });
    return fac;
  }
  public findSpeciality(facilityId, specialityId) {
    if(this.isPatientTask) return null;
    if (facilityId) {
      let facilities = this.getAttributeForListingType('specialities', true)
      let fac = facilities.find(facility => {
        return facility.facilityId == facilityId;
      });
      if(!fac) return null;
      let spec = fac['specialities'].find(speciality => {
        return speciality.specialityId == specialityId;
      })
      return spec;
    } else {
      let specList = this.getSpecialities();
      let spec = specList.find(speciality => {
        return speciality.specialityId == specialityId;
      })
      return spec;
    }

  }

  public getFacilityByFacilityId(facId) {
    let facility = this.getAttributeForListingType('facList', true)?.find(fac => fac.facilityId == facId);
    // console.log('facility????', facility)
    if (facility) {
      return facility;
    } else {
      return null;
    }
  }

  public setIsBookingSubService(data) {
     this.isBookingSubService = data;
  }

  public getIsBookingSubService() {
    return this.isBookingSubService;
  }
  public findPractitioner(facilityId, practitionerId) {
    if(this.isPatientTask) return null;
    if (facilityId) {
      let facilities = this.getAttributeForListingType('specialities', true)
      let fac = facilities.find(facility => {
        return facility.facilityId == facilityId;
      });
      if(!fac) return null;
      let prac = fac['practitioners'].find(practitioner => {
        return practitioner.resourceId == practitionerId;
      })
      return prac;
    } else {
      let pracList = this.getPractitioners();
      let prac = pracList.find(practitioner => {
        return practitioner.resourceId == practitionerId;
      })
      return prac;
    }

  }
  public findLinkedPatient(uhid) {
    return this.userInfo['linkedPatients'].find(patient => {
      return patient.uhid == uhid;
    })
  }

  public getSpecialityByPractId(practId, facId) {
    let facility = this.getAttributeForListingType('specialities', true).find(fac => fac.facilityId == facId);
    if (facility) {
      let practitioner = facility.practitioners.find(pract => pract.resourceId == practId)
      if (!practitioner)
        practitioner = this.getPractitioners().find(pract => pract.resourceId == practId)
      if (practitioner) {
        let specialityId = practitioner.specialityId
        let speciality = facility.specialities.find(spec => spec.specialityId == specialityId);
        // console.log('speciality', speciality)
        if (speciality) {
          return speciality
        } else {
          let allSpecialities = this.getSpecialities();
          speciality = allSpecialities.find(spec => spec.specialityId == specialityId);
          if (speciality)
            return speciality
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

    public getAllSpecialities(getUniqueSpeciality: boolean = false, getFromBookingEnabledFacility: boolean = false, getOnlyPractitionerAvailableSpeciality: boolean = false,hideExpressSpeciality?):Array<any> {
    let allFacilities = this.getAttributeForListingType('facilityServices', true)?.facilities;
    if (getFromBookingEnabledFacility) {
      let facinfo = this.getAttributeForListingType('facilities');
      allFacilities = _.cloneDeep(allFacilities).filter(fac => {
        if (!fac.practitioners?.length) return false;
        let facility = facinfo?.facilities?.find(f => f.facilityId == fac.facilityId)
        if (facility) {
          let hidden = facility.facilityControls && facility.facilityControls.schedulingRules && facility.facilityControls.schedulingRules.pxAppSettings && facility.facilityControls.schedulingRules.pxAppSettings.hideFacilityForNormalVisit;
          
          return hidden ? false : true;
        } else {
          return true;
        }
      })
    }
    let allSpecialitiesArray = allFacilities.map(facility => {
      let specialities = facility.specialities;
      if (getOnlyPractitionerAvailableSpeciality) {
        specialities = facility.specialities.filter(spec => {
          return facility.practitioners.findIndex(pract => pract.specialityId == spec.specialityId) > -1
        })
      }
      specialities.map(spec => {
        spec.facilityId = facility.facilityId;
        return spec;
      });
      return _.cloneDeep(specialities);
    });
    let allSpecialities = [].concat.apply([], allSpecialitiesArray);
    if(hideExpressSpeciality){
      allSpecialities=allSpecialities.filter(s=>s?.specialityId!=='ECSP')
    }
    if (getUniqueSpeciality) {
      allSpecialities = allSpecialities.filter((spec, ind) => ind == allSpecialities.findIndex(a => a && a.specialityId == spec?.specialityId))
    }
    console.log('getAllSpecialities allSpecialities', allSpecialities);
    return _.cloneDeep(allSpecialities);
  }

  public getSpecialities(facilityId?: string, type?: visitType, hideExpressSpeciality?, hideSpecialitywithoutPract?) {
    // let facilities = this.updateInfo['facilityServices']['facilities'];
    let facilities = this.getAttributeForListingType('specialities', true)
    if (facilityId) {
      facilities = facilities.filter(facility => {
        return facility.facilityId == facilityId;
      })
    }
    let specialities = facilities.map(facilitity => {
      let fArray = facilitity.specialities
      return fArray.map(f => {
        return {
          ...f,
          facilityId: facilitity.facilityId
        }
      })
    })
    specialities = [].concat.apply([], specialities);
    specialities = specialities.filter((speciality, index, arr) => {
      return arr.findIndex(sp => {
        return speciality.specialityId == sp.specialityId;
      }) == index;
    });
    if(hideExpressSpeciality){
      specialities = specialities.filter(s=>s.specialityId!=='ECSP')
    }
    let combinedSpecialities = specialities.map(speciality => {
      if (type) {
        let practitioners = this.getPractitioners(speciality.specialityId, type, facilityId);
        speciality.pracCount = practitioners.length;
      }
      return speciality
    })
    if(hideSpecialitywithoutPract)
      combinedSpecialities = combinedSpecialities.filter(s=>s.pracCount>0);
    return combinedSpecialities;
  }
  public getPractitioners(specialityId?: string, type?: visitType, facilityId?: string, hideExpressSpeciality?) {
    // let facilities = this.updateInfo['facilityServices']['facilities'];
    let facilities = this.getAttributeForListingType('specialities', true)
    if (facilityId) {
      facilities = facilities.filter(facility => {
        return facility.facilityId == facilityId;
      })
    }
    let practitioners = facilities.map(facilitity => {
      let fArray = facilitity.practitioners
      return fArray.map(f => {
        return {
          ...f,
          tfacilityId: facilitity.facilityId
        }
      })
    })
    practitioners = [].concat.apply([], practitioners);
    practitioners = practitioners.reduce((rv, x) => {
      if (type && type == 'VIDEO' && (x['schedulerControls']['consultType'] == 'HOSPVIDEO' || x['schedulerControls']['consultType'] == 'VIDEO')) {
        (rv[x['resourceId']] = rv[x['resourceId']] || []).push(x);
      } else if (type && type != 'VIDEO' && (x['schedulerControls']['consultType'] == 'HOSPVIDEO' || x['schedulerControls']['consultType'] != 'VIDEO')) {
        (rv[x['resourceId']] = rv[x['resourceId']] || []).push(x);
      } else if (!type) {
        (rv[x['resourceId']] = rv[x['resourceId']] || []).push(x);
      }
      return rv;
    }, {});
    practitioners = Object.values(practitioners).map((prac: Array<any>) => {
      let tempArray = prac[0];
      tempArray['facList'] = [];
      prac.forEach(element => {
        let facility = this.findFacility(element.tfacilityId);
        tempArray['facList'].push(facility);
      });
      return tempArray;
    })
    if(hideExpressSpeciality){
      practitioners = practitioners.filter(s=>s.specialityId!=='ECSP')
    }
    if (specialityId) {
      return practitioners.filter(practitioner => {
        return practitioner.specialityId == specialityId;
      })
    } else {
      return practitioners;
    }
  }

  //API SERVICES

  public updateCheck(): Observable<any> {
    const cacheKey = 'updateCheck';
    
    return this.getCachedObservable(cacheKey, () => {
      const contentHeaders = this.getRouterBasedUpdate();
      const payload = {
        appVersion: environment['APP_VERSION'],
        versions: contentHeaders
      };
      
      return this.initApiCall(payload).pipe(
        tap(() => {
          this.configLoaded = true;
          this.configLoadedSubject.next(true);
        }),
        timeout(30000), // 30 second timeout
        retry(2), // Retry twice on failure
        catchError(error => {
          console.error('UpdateCheck failed:', error);
          this.configLoadedSubject.next(false);
          return of(null);
        })
      );
    }, 5); // Cache for 5 minutes
  }
  private initApiCall(payload): Observable<any> {
    return this.http.post(`${environment['API_URL']}${AppConstant.API_CONTENT}/updateCheck`, payload, { reportProgress: true }).pipe(
      switchMap(success => this.setUpdateInfo(success).pipe(map(() => success))),
      catchError(error => {
        console.error('API call failed:', error);
        return this.setUpdateInfo(null).pipe(map(() => null));
      })
    );
  }
  public getSlotList(practitionerIdOrPayload:any, facilityId?:string, dates?:Array<string>, visitType?:visitType, clinicCode?): Observable<any> {
    
  let payload: any;
  if (typeof practitionerIdOrPayload === 'object') {
    payload = practitionerIdOrPayload;
  } else {
    payload = {
      practitionerId: practitionerIdOrPayload,
      dates: dates
    };
    if (visitType) payload['visitType'] = visitType;
    if (facilityId) payload['facilityId'] = facilityId;
    if (clinicCode) payload['clinicCode'] = clinicCode;
  }  
  
  if (payload.locale) payload['locale'] = payload.locale;
  if (payload.patientId) payload['patientId'] = payload.patientId;
  if (payload.resourceClass) payload['resourceClass'] = payload.resourceClass;
  if (payload.resourceType) payload['resourceType'] = payload.resourceType;

  return Observable.create(observer => {
      this.http.post(`${this.repoUrl}api/schedules/getavailability`, payload).subscribe(success => {
        console.log('getavailability', success);
        observer.next(success['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
  })
  }
  public confirmAppointment(data:any): Observable<any> {
    let payload = {
      personId: this.userInfo.personDetails.personId,
      // patientPersonId: data.patientPersonId,
      // uhid: data.uhid,
      // facilityId: data.facilityId,
      // clinicCode: data.clinicCode,
      // date: data.date,
      // time: data.time,
      // personName: data.patientName,
      // dob: data.dob,
      // gender: data.gender,
      // practitionerName: data.practitionerName,
      // specialityName: data.specialityName,
      // patientName: data.patientName,
      // visitType: data.visitType,
      localeCode: this.currentLanguage,
      ...data
    }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}${AppConstant.API_APPOINTMENT}/confirm`, payload, { reportProgress: true}).subscribe(success => {
        observer.next(success);
        this.npsRatingSubject.next(true)
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }
  public getUpcomingAppointments(): Observable<any> {
    let payload = {
      personId: this.userInfo.personDetails.personId,
    }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}${AppConstant.API_APPOINTMENT}/getupcoming`, payload, { reportProgress: true}).subscribe(success => {
        observer.next(success);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }

  public getGeoLocation(): Observable<any>  {
    return Observable.create(observer => {
      if (this.geoLocation) {
        observer.next({ status: true, data: this.geoLocation });
      }
      else if (navigator.geolocation) {
        navigator.permissions.query({ name: 'geolocation' })
          .then(permission => {
            console.log('navigator response----',permission)
            if (permission.state != 'denied') {
              var options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
              }
              navigator.geolocation.getCurrentPosition((position: any) => {
                console.log('Navigator permission success',position)
                if (position) {
                  let lat = position.coords.latitude;
                  let lon = position.coords.longitude;
                  this.setGeoLocation({ lat: lat, lon: lon });
                  observer.next({ status: true, data: { lat: lat, lon: lon } });
                } else {
                  observer.next({ status: false, message: 'ERROR' });
                }
              },(err)=>{
                console.log('navigator permission catch----',err)
                observer.next({ status: false, message: 'ERROR' });
              },
              options)
            } else {
              observer.next({ status: false, message: 'DECLINED' });
            }
          })

      } else {
        observer.next({ status: false, message: 'NOOPTION' });
      }
    })
  }
  public setGeoLocation(val) {
    this.geoLocation = val;
  }

  /**
   * Sorts facilities by distance from user location
   * @param facilities - Array of facilities to sort
   * @returns Observable of sorted array of facilities (closest first)
   */
  public sortFacilitiesByUserLocation(facilities: any[]): Observable<any[]> {
    if (!facilities || facilities.length === 0) {
      return of(facilities || []);
    }

    // Get user location from service
    let userLocation = this.geoLocation;
    // console.log('userLocation in sortFacilitiesByUserLocation', userLocation);
    // If no geoLocation, retrieve it using getGeoLocation
    if (!userLocation || !userLocation.lat || !userLocation.lon) {
      return this.getGeoLocation().pipe(
        map((geoData: any) => {
          // console.log('geoData in sortFacilitiesByUserLocation', geoData);
          if (geoData && geoData.status && geoData.data) {
            userLocation = geoData.data;
            return this.sortFacilities(facilities, userLocation);
          }
          // If unable to get location, return unsorted facilities
          return facilities;
        })
      );
    }

    // If geoLocation exists, sort synchronously
    return of(this.sortFacilities(facilities, userLocation));
  }

  /**
   * Helper method to sort facilities by distance
   * @param facilities - Array of facilities to sort
   * @param userLocation - User location object with lat and lon
   * @returns Sorted array of facilities
   */
  private sortFacilities(facilities: any[], userLocation: { lat: number; lon: number }): any[] {
    if (!userLocation || !userLocation.lat || !userLocation.lon) {
      return facilities;
    }

    const userLat = userLocation.lat;
    const userLon = userLocation.lon;

    // Calculate distance for each facility and sort
    return facilities.map(facility => {
      const facilityLat = facility['facilityGeoLocation'].split(',')[0] || 0;
      const facilityLon = facility['facilityGeoLocation'].split(',')[1] || 0;
      
      // Calculate distance using Haversine formula
      const distance = this.getDistanceFromLatLonInKm(userLat, userLon, facilityLat, facilityLon);
      // console.log('distance for facility', facility['facilityName'], distance);
      return {
        ...facility,
        distance: parseFloat(distance)
      };
    }).sort((a, b) => {
      // Sort by distance (closest first)
      return (a.distance || Infinity) - (b.distance || Infinity);
    });
  }

  /**
   * Helper method to calculate distance between two coordinates using Haversine formula
   * @param lat1 - Latitude of first point
   * @param lon1 - Longitude of first point
   * @param lat2 - Latitude of second point
   * @param lon2 - Longitude of second point
   * @returns Distance in kilometers
   */
  private getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number): string {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d.toFixed(2);
  }

  /**
   * Helper method to convert degrees to radians
   * @param deg - Degrees to convert
   * @returns Radians
   */
  private deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  public getCityDetails(isPatientSignup = false, standalone = false): Observable<any> {
    let payload = {
      locale: this.currentLanguage,
    }
    return Observable.create(observer => {
      if (!isPatientSignup && !standalone) {
        this.http.post(`${this.repoUrl}api/masters/GetCityDetails`, payload).subscribe(data => {
          observer.next(data);
        }, error => {
          observer.error(this.getErrorMessage(error));
        })
      } else if(isPatientSignup){
        this.http.post(`${environment['API_URL']}api/content/getCityCodes`, payload, { reportProgress: true }).subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, error => {
          // this.toast.showToast(null, error['message'], TOAST_ERROR);
          observer.error(this.getErrorMessage(error));
        })
      } else if(standalone){
        this.http.post(`${environment['VISIT_API_URL']}api/patientKiosk/cityCodesMaster`, payload).subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, error => {
          // this.toast.showToast(null, error['message'], TOAST_ERROR);
          observer.error(this.getErrorMessage(error));
        })
      }
    })
  }
  public getMasters(type: string, standalone = false): Observable<any> {
    let payload = {
      master: type,
      locale: this.currentLanguage,
    }
    let url = `${this.repoUrl}api/masters/getMasters`
    if (standalone) {
      url = `${environment['VISIT_API_URL']}api/patientKiosk/getMasters`
    }
    return Observable.create(observer => {
      this.http.post(url, payload).subscribe(data => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }
  public listPayerGroup(facilityId: string, standalone = false): Observable<any> {
    let payload = {
      facilityId: facilityId
    }
    let url = `${this.repoUrl}api/masters/listPayerGroup`
    if(standalone){
      url = `${environment['VISIT_API_URL']}api/patientKiosk/payerGroupMaster`
    }
    return Observable.create(observer => {
      this.http.post(url, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public getPayersList(facilityId: string, payerGroupCode: string, standalone = false): Observable<any> {
    let payload = {
      facilityId: facilityId,
      payerGroupCode: payerGroupCode
    }
    let url = `${this.repoUrl}api/masters/listPayer`;
    if (standalone) {
      url = `${environment['VISIT_API_URL']}api/patientKiosk/payerMaster`
    }
    return Observable.create(observer => {
      this.http.post(url, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public getPolicyList(facilityId: string, payerGroupCode: string, payerCode: string, standalone): Observable<any> {
    let payload = {
      facilityId: facilityId,
      payerGroupCode: payerGroupCode,
      payerCode: payerCode
    }
    let url = `${this.repoUrl}api/policy/getPolicyTypes`;
    if (standalone) {
      url = `${environment['VISIT_API_URL']}api/patientKiosk/policyTypeMaster`
    }
    return Observable.create(observer => {
      this.http.post(url, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public addLinkedPatient(data): Observable<any> {
    return new Observable(observer => {
      this.getExternalInterface().pipe(take(1)).subscribe(extInterface => {
        if (extInterface) {
          const SSO_TOKEN = this.cookie.getStorage(AppConstant.ACCESS_TOKEN) ? this.cookie.getStorage(AppConstant.ACCESS_TOKEN) : ''
          this.getSSOUserObject().pipe(take(1)).subscribe(userObj => {
            const payload = {
              token: SSO_TOKEN,
              mobile: this.getPersonMobile(),
              countryCode: this.getPersonCountryCode(),
              username: userObj.username
            }
            this.initAddLinkedPatient(data, payload).subscribe(response => {
              observer.next(response);
            }, err => {
              observer.error(err)
            })
          }, err => {
            this.initAddLinkedPatient(data, null).subscribe(response => {
              observer.next(response);
            }, err => {
              observer.error(err)
            })
          })
        } else {
          this.initAddLinkedPatient(data, null).subscribe(response => {
            observer.next(response);
          }, err => {
            observer.error(err)
          })
        }
      }, err => {
        this.initAddLinkedPatient(data, null).subscribe(response => {
          observer.next(response);
        }, err => {
          observer.error(err)
        })
      })
    })
  }
  public initAddLinkedPatient(data, externalInterfaceData): Observable<any> {
    let payload = {
      ...data,
      personId: this.userInfo.personDetails.personId,
      personName: this.userInfo.personDetails.personName,
      mobile: this.userInfo.personDetails.mobile,
      locale: this.currentLanguage,
      ssoDetails: externalInterfaceData
      // email: this.userInfo.personDetails.email,

    }
    return new Observable(observer => {
      this.http.post(`${environment['API_URL']}api/persons/registerNewPatient`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        this.toast.showToast(null, data['message'] || 'Patient registered successfully', AppConstant.TOAST_INFO);
        this.syncPatientProfile()
        console.info('registerNewPatient', data);
      }, error => {
        observer.error(error);
      })
    });
  }

  public updateAfterPatientModification(repoToken, apiToken) {
    if (repoToken) {
      this.setSessionOnlyStorage(REPO_TOKEN, repoToken['token']);
      this.setRepoUrl(repoToken['url']);
    }
    if(apiToken) {
      this.setSessionOnlyStorage(USER_TOKEN, apiToken);
    }
  }

  public startRegTransaction(regParams, requestParams): Observable<any> {
    let payload = {
      ...regParams,
      personId: this.userInfo.personDetails.personId,
      request: {
        ...requestParams,
        personId: this.userInfo.personDetails.personId,
        personName: this.userInfo.personDetails.personName,
        mobile: this.userInfo.personDetails.mobile,
        email: this.userInfo.personDetails.email,
      }
    }
    return Observable.create(observer => {
      // this.http.post(`${environment['API_URL']}api/persons/registerNewPatient`, payload, { reportProgress: true }).subscribe((data) => {
      //   observer.next(data['data']);
      // }, error => {
      //   observer.error(this.getErrorMessage(error));
      // })
    });
  }
  public getVisitHistory(uhid: string): Observable<any>{
    let payload = {
      patientId: uhid
    }
    return Observable.create(observer => {
      this.http.post(`${this.repoUrl}api/visits/list`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public getVisitReport(uhid: string, encounterid: string, type: string, reportId:string=null):Observable<any> {
    let payload = {
      patientId: uhid,
      visitId: encounterid,
      limit: 50,
      reportId: reportId
    };
    return Observable.create(observer => {
      this.http.post(`${this.repoUrl}api/visits/reports`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public geReportById(uhid: string, reportId: string, facilityId: string):Observable<any> {
    let payload = {
      patientId: uhid,
      reportId: reportId,
      facilityId: facilityId
    };
    return Observable.create(observer => {
      this.http.post(`${this.repoUrl}api/visits/getReportById`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public getUploadedReport(uhid: string, encounterid: string, type: string): Observable<any> {

    let payload = {
      patientId: uhid,
      source:'BOTH'
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/getreports`, payload, {reportProgress: true}).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public removePersonalReport(docId: string):Observable<any> {
    let payload = {
      docId: docId
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/removereport`, payload, {reportProgress: true}).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public convertToPDF(data):Observable<any> {
    let payload = {...data};
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/convertToPDF`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public getDownloadContent(url: string, token: string, isCommonView?:boolean): Observable<any> {
    let header = {
      'Authorization': token
    }
    if (isCommonView) {
      url = `${url}?preview=common`
    }
    let responseType:'json' = 'text' as 'json'
    return Observable.create(observer => {
      this.http.get<string>(url, { headers: new HttpHeaders(header), responseType: responseType }).subscribe((data) => {
        observer.next(data);
      }, error => {
        console.error(error)
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public openFacilityLocation(facilityId) {
    let fac = this.findFacility(facilityId);
    let location = `https://www.google.com/maps/search/?api=1&query=${fac['facilityGeoLocation']}`;
    this.openLocation(location, '_blank');
  }
  public getRegisterationParams(isPatientSignup, standalone): Observable<any> {
    let payload = {};
    return Observable.create(observer => {
      if (!isPatientSignup && !standalone) {
        this.http.post(`${environment['API_URL']}api/persons/getRegistrationParamsDetails`, payload, { reportProgress: true }).subscribe((data) => {
          observer.next(data['data']);
        }, error => {
          // this.toast.showToast(null, error['message'], TOAST_ERROR);
          observer.error(this.getErrorMessage(error));
        })
      } else if (isPatientSignup) {
        this.http.post(`${environment['API_URL']}api/security/getSignUpConfig`, payload, { reportProgress: true }).subscribe((data) => {
          const signupData = this.generateSignupData(data['data'])
          observer.next(signupData);
        }, error => {
          // this.toast.showToast(null, error['message'], TOAST_ERROR);
          observer.error(this.getErrorMessage(error));
        })
      } else if (standalone) {
        this.http.post(`${environment['VISIT_API_URL']}api/patientKiosk/getRegistrationParamsDetails`, payload, { reportProgress: false }).subscribe((data) => {
          const regData = data['data']['registrationParams'] //this.generateRegData()
          observer.next(regData);
        }, error => {
          // this.toast.showToast(null, error['message'], TOAST_ERROR);
          observer.error(this.getErrorMessage(error));
        })
      }
    });
  }
  public getPatientPolicy(payload): Observable<any> {
    payload.mobile = this.getPersonCountryCode() + this.getPersonMobile();
    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/outpatients/getinsuranceDetails`, payload, { reportProgress: false }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(error);
      })
    });
  }

  public setPayerGrpSubject(){
    this.payerGrpUpdated.next(true);
  }

  public getPatientPolicyDetails(data): Observable<any> {
    let payload = data.map(d => {
      d.version = 'v1';
      return d;
    })
    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/schedules/getPatientInsuranceDetails`, payload, { reportProgress: false }).subscribe(data => {
        observer.next(data['data']);
      }, error => {
        observer.error(error);
      })
    });
  }
  public getCountryList(isPatientSignup = false, standalone = false): Observable<any> {
    let payload = {
      locale: this.currentLanguage
    };

    return Observable.create(observer => {
      if (!isPatientSignup && !standalone) {
        if (this.countryList && this.countryList.length > 0) {
          observer.next(this.countryList);
          observer.complete();
          return;
        }
        this.http.post(`${this.repoUrl}api/masters/countrycodes`, payload).subscribe((data: any) => {
          this.countryList = data;
          observer.next(data);
          observer.complete();
        }, error => {
          observer.error(this.getErrorMessage(error));
        })
      } else if(isPatientSignup) {
        this.http.post(`${environment['API_URL']}api/content/getCountryCodes`, payload, { reportProgress: true }).subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, error => {
          // this.toast.showToast(null, error['message'], TOAST_ERROR);
          observer.error(this.getErrorMessage(error));
        })
      } else if (standalone) {
        this.http.post(`${environment['VISIT_API_URL']}api/patientKiosk/countryCodesMaster`, payload, { reportProgress: false }).subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, error => {
          // this.toast.showToast(null, error['message'], TOAST_ERROR);
          observer.error(this.getErrorMessage(error));
        })
      }
    });
  }
  public getBloodGroups(standalone): Observable<any> {
    let payload = {
      locale: this.currentLanguage
    };
    let url = `${this.repoUrl}api/masters/bloodgroups`
    if(standalone)
      url = `${environment['VISIT_API_URL']}api/patientKiosk/bloodGroupMaster`
    return Observable.create(observer => {
      this.http.post(url, payload).subscribe((data: any) => {
        observer.next(data);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getSavedCountryList() {
    return this.countryList;
  }
  public getUserCatalogs() {
    return [];
  }
  public getGenFeedbackData(directiveGrp, conceptGrp): Observable<any> {
    let payload = {
      patientId: '',
      encounterId: '',
      directiveCode: directiveGrp,
      conceptCode: conceptGrp,
      templateType: 'FEEDBACK'
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/content/getTemplate`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public recordGeneralFeedback(payload): Observable<any> {
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/content/recordTemplate`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public getUserProfile(): Observable<any> {
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}${AppConstant.API_EXTERNAL_AUTH}/getUserProfile`, {}, { reportProgress: true }).subscribe(success => {
        observer.next(success);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }

  public getClinics(filter: object): Observable<any>{
    let payload = {
      filter: filter
    }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/listClinics`, payload, { reportProgress: true }).subscribe(success => {
        observer.next(success);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }


  public getUserIdForPatient(payload): Observable<any> {
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/getAltIdForPatient`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(error);
      })
    });
  }

  public getClinicInfo(facilityId,code,skillSet): Observable<any>{
    let payload = {
      facilityId: facilityId,
      clinicCode: code,
      skillSets: skillSet
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/getClinicInfo`, payload, { reportProgress: true }).subscribe(success => {
        observer.next(success);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }

  public getListSkillSetMasters(): Observable<any>{
    let payload = {};
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/listSkillSetMasters`, payload, { reportProgress: true }).subscribe(success => {
        observer.next(success);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }

  public openSocialMedia(type) {
    if(type == 'fb'){
      let link = 'https://www.facebook.com/nahdihope';
      this.openLocation(link, "_blank");
    }
    if(type == 'yt'){
      let link = 'https://www.youtube.com/user/nahdihope';
      this.openLocation(link, "_blank");
    }
    if(type == 'insta'){
      let link = 'https://www.instagram.com/nahdihope';
      this.openLocation(link, "_blank");
    }
    if(type == 'linkedin'){
      let link = 'https://www.linkedin.com/company/al-nahdi-medical-co-';
      this.openLocation(link, "_blank");
    }
    if(type == 'twitter'){
      let link = 'https://twitter.com/nahdihope';
      this.openLocation(link, "_blank");
    }

  }

  public download(type){
    if(type == 'android'){
      let link = 'https://play.google.com/store/apps/details?id=com.nahdi.nahdipx';
      this.openLocation(link, "_blank");
    }
    if(type == 'apple'){
      let link = 'https://apps.apple.com/nz/app/nahdicare-clinics/id1462753220';
      this.openLocation(link, "_blank");
    }
  }

  public validatePatientTask(key: string): Observable<any> {
    let payload = {
      key: key,
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/schedules/validatePatientTask`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public validatePatientView(key: string, patientId?:string, otp?:string): Observable<any> {
    let payload = {
      key: key,
      patientId: patientId,
      otp:otp
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/schedules/validatePatientView`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
        // observer.next({type: 'LOGIN'})
      })
    });
  }

  public validatePatientAppointment(key): Observable<any>{
    const payload = {
      key: key
    }
    // const payload = { "apptRefNo": "171783", "password": "8weJEmWB", "linkType": "P" }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/schedules/validatePatientAppointment`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
        // observer.next({type: 'LOGIN'})
      })
    });
  }
  public validatePatientBill(key): Observable<any>{
    const payload = {
      key: key
    }
    // const payload = { "apptRefNo": "171783", "password": "8weJEmWB", "linkType": "P" }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/schedules/validatePatientBill`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
        // observer.next({type: 'LOGIN'})
      })
    });
  }

  public getApplicableStatus(task) {
    if(!task || !task['applicableStatus']) return [];
    const status = task['applicableStatus'].find(status => status['code'] == task['currentStatus']);
    if(!status) return ;
    const seqNo = parseInt(status['seqNo']);
    return task['applicableStatus'].filter(status => (parseInt(status['seqNo']) >= seqNo) && status['code'] != task['currentStatus']);
  }
  public getCurrentStatus(task) {
    if(!task || !task['applicableStatus']) return [];
    const status = task['applicableStatus'].find(status => status['code'] == task['currentStatus']);
    return status;
  }

  public getConcept(taskDetail: Object, task: Object): any {
    let noteContent;
    if (taskDetail['taskGroup']['multiDisciplinaryControls'] && taskDetail['taskGroup']['multiDisciplinaryControls']['multiDisciplinaryDocWfyn'] === 'Y') {
      if (task['multiDisciplinaryNote'])
        noteContent = task['multiDisciplinaryNote'];
      else
        noteContent = task['noteContent'];
      noteContent['topics'].map(t => {
        let showControl = _find(task['multiDisciplinaryNoteControl'], { topicId: t['id'] });
        t['displayOption'] = showControl ? showControl['options'] : 'E';
      });
    } else {
      noteContent = task['noteContent'];
    }

    let concept = {
      label: task['taskDesc'],
      noteCode: task['noteTypeCode'] || task['noteCode'],
      id: task['noteTypeCode'] || task['noteCode'],
      noteContent: noteContent ? noteContent : task['noteContent'],
      noteControls: task['noteControls']
    }
    return concept;
  }

  public prefillWorkflowDrivers(concept: any, wfDrivers: Array<WFDriverElement>) {
    if (!Array.isArray(wfDrivers) || wfDrivers.length == 0) return concept;
    if (concept.noteContent && Array.isArray(concept.noteContent.topics)) {
      concept.noteContent.topics.map(t => {
        t.sections.map(s => {
          let wfDataForSection = wfDrivers.find(ds => ds.domainCode === s.domainCode && ds.domainName === s.domainName);
          if (wfDataForSection && wfDataForSection.domainValue) {
            if (s.type === 'masterLinked') {
              const splittedVal = wfDataForSection.domainValue.split('#');
              const selected = { name: splittedVal[1], code: splittedVal[0] };
              s['selectedMaster'] = selected;
              s['selectedValue'] = selected.name;
              s['selectedCode'] = selected.code;
            } else {
              s['selected'] = wfDataForSection.domainValue;
            }
          }
        });
      })
    }
    return concept;
  }

  public updateTaskInfo(payload): Observable<any> {
    payload['locale'] = this.currentLanguage;
    return Observable.create(observer => {
      this.http.post(environment['API_URL'] + 'api/workflow/updateTaskStatus', payload, { reportProgress: true }).subscribe(result => {
        let data = [];
        if (result && result['status'] === "SUCCESS" && Array.isArray(result['tasksList']))
          data = result['tasksList'];
        // result['taskList'].forEach(rt=> Array.isArray(rt['ret_task_info']) ? rt['ret_task_info'].forEach(t=> data.push(t)) : null)
        observer.next(data || true);
      }, error => {
        observer.error(false);
        console.error('Unable to retrive task details');
      });
    });
  }

  public getPayLoad(task, eventInfo, noteCode, noteContent, action, outcome, type, reportingOutcomes, taskAscNo, info, contractSeq?): any {
    console.log('action ', action);
    if (type !== 'save' && !action) return;
    if(noteContent && Array.isArray(noteContent.topics) && noteContent.topics.some(t=> Array.isArray(t.sections) && t.sections.some(s=>s.type==='richTextEditor' && s.templateVaraibleValues))){
      let value = {};
      if(contractSeq)
        value['SYS_CONTRACT_S_NO'] = contractSeq;
      noteContent.topics.forEach(t=>{
        t.sections.forEach(s=>{
          if(s.type==='richTextEditor' && s.templateVaraibleValues){
            Object.assign(value, s.templateVaraibleValues);
            delete s.templateVaraibleValues
          }else if(s.domainCode && s.selected && s.type!=='richTextEditor'){
            value[s.domainCode] = s.selected;
          }
        })
      });
      noteContent['templateVaraibleValues'] = value;
    }

    var payload = {
      "header": eventInfo,
      "taskUpdates": [
        {
          "entityId": info['entityId'],
          "facilityId": task['facilityId'],
          "patientId": task['patientId'] || eventInfo['patientId'],
          "taskId": taskAscNo,
          "taskSeqNo": task['taskSeqNo'],
          "currentStatus": task['currentStatus'],
          "newStatus": action,
          "updatedBy": info['personId'],
          "updatedDateTime": this.getMoment().format(),
          "linkedNoteId": noteCode,
          "linkedNoteContent": noteContent,
          "outcomes": outcome,
          "reportingFields": reportingOutcomes,
          "taskdtlascnno": task['taskdetailacsnno'],
          "encounterSeq": task['encSeq'],
          "taskStartDttm": task['_taskStartTime'],
          "actionType": task['_actionType'],
          "externalEventType": task['externalEventType'] || null
        }
      ],
      "printLabels": false
    }
    if (type == 'submit')
      payload.taskUpdates[0]['newStatus'] = action;
    else if (type == 'save') {
      payload.taskUpdates[0]['newStatus'] = task['currentStatus'];
      payload.taskUpdates[0]['actionType'] = 'DRAFT';
    }


    return payload;
  }

  public startSurvey(key: string): Observable<any> {
    let payload = {
      key: key,
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/security/startsurvey`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public authSurvey(payload): Observable<any> {
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/security/authsurvey`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  // set info from validatePatientTask Api
  public setUserInfoForTask(userInfo, credentials, repo) {
    this.userInfo = {
      personDetails: userInfo,
      credentials: credentials,
      repoDetails: repo,
    }
  }

  public setPatientTask(status:boolean) {
    this.isPatientTask = status;
  }
  public getPatientTask() {
    return this.isPatientTask;
  }
  public getPersonInfo(){
    return this.userInfo;
  }

  public setLocaleLabels(labels) {
    this.localeLabels = labels;
  }
  public getLocaleLabels() {
    return this.localeLabels;
  }
  // public setGTMTagConfig({ enabled, key }) {
  //   this.isTagsEnabled = enabled;
  //   this.GTMContainerId = key;
  // }
  // public getGTMContainerId(): string {
  //   // console.log(this.isTagsEnabled, this.GTMContainerId);
  //   return this.isTagsEnabled ? this.GTMContainerId : 'GTM';
  // }
  // public isGTMEnabled(): boolean {
  //   return ;
  // }

  public setTruncateInfo(){
    this.getConfigurationInfo.subscribe(data => {
      if (data['integrationSettings']) {
        this.roundOrTruncate = data['integrationSettings']['roundOrTruncate'];
        this.roundOfDecimals = data['integrationSettings']['roundOfDecimals'];
      }
    })
  }

  public fixDecimalPlaces(actvalue: number): number {
    if (!actvalue) { return Number(actvalue); }
    else {
        let value = actvalue.toString();
        if (this.roundOrTruncate == 'T') {
            let strValue = parseFloat(value).toFixed(Number(this.roundOfDecimals) + 1).slice(0, -1);
            return Number(strValue);
        } else {
            let strValue = (Math.round(parseFloat(value) * 100) / 100).toFixed(2);
            return Number(strValue)
        }
    }
  }

  public getPatientAddress(): Observable<any> {
    let payload = {
      personId: this.userInfo.personDetails.personId,
    }
    return Observable.create(observer => {
      this.http.post(`${this.repoUrl}api/mpi/getPatientAddress`, payload).subscribe(response => {
        if (response["status"] === "SUCCESS")
          observer.next(response['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }
  public updateAddress(patientId, patientAddress, linkAddress): Observable<any> {
    let payload = {
      personId: this.userInfo.personDetails.personId,
      patientId: patientId,
      patientAddress: patientAddress,
      linkAddress: linkAddress
    }
    return Observable.create(observer => {
      this.http.post(`${this.repoUrl}api/mpi/updatePatientAddresses`, payload).subscribe(response => {
        if (response["status"] === "SUCCESS")
          observer.next(response['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }
  public setLoginContext(context, restrict?) {
    if(restrict)
      this.featureFlagsService.restrictViewsOnPermission(context['type'])
    if (context['type'] == LOGIN_CONTEXT['TASK']) {
      this.setPatientTask(true)
    }
    sessionStorage.setItem(CTX, JSON.stringify(context));
    this.loginContext = context;
  }
  public getLoginContext() {
    let context = this.loginContext;
    if(!context) {
      context = JSON.parse(sessionStorage.getItem(CTX));
      if(!context) {
        const queryParams = this.route.queryParams['_value'];
        this.router.navigate([`${AppConstant.ROUTE_LOGIN}`], { queryParams: queryParams});
      }else {
        this.featureFlagsService.restrictViewsOnPermission(context['type'])
        this.loginContext = context;
      }
    }
    return context;
  }
  public removeLoginContext() {
    this.loginContext = null;
  }

  public getContractSeq(task, patientInfo): Observable<any> {
    let payload = {
      facilityId: task['facilityId'],
      patientId:patientInfo['patientId']
    };
    return new Observable(observer => {
      this.http.post(`${environment['API_URL']}api/lab/patContractSeq`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  private presentAppPromotion(updateInfo) {
    // updateInfo.configuration.pxAppSettings.showAppPromo = true;

    this.route.queryParamMap.subscribe(params => {
      let action = params.get('action');
      if (this.router.url.includes(AppConstant.ROUTE_WEBVIEW) ||  this.router.url.includes(AppConstant.ROUTE_EMBED_APPT)) {
        action = 'webview'
      }
      if (updateInfo && updateInfo.configuration && updateInfo.configuration.pxAppSettings && updateInfo.configuration.pxAppSettings.showAppPromo) {
        if (!this.cookie.getCookie('APPPROMOCLOSED') || (updateInfo.configuration.pxAppSettings.repeatAppPromo && sessionStorage.getItem('APPPROMOCLOSED') !== 'true')) {
          this.appPromoSubject.next({ show: true, type: 'APPPROMO', expireDays: updateInfo.configuration.pxAppSettings.closeExpireDays, action: action, repeatAppPromo: updateInfo.configuration.pxAppSettings.repeatAppPromo,queryParams: params })
        }
      }
    })
  }

  public getPatientTaskDetails(context): Observable<any>{
    return new Observable(observer => {
      let payload = {
        key: context.taskKey,
        taskId: context.taskId,
        patientId: context.patientId,

      };
      this.http.post(`${environment['API_URL']}api/schedules/getPatientTaskDetails`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }
  public getPatientTaskLists(patientInfo): Observable<any>{
    return new Observable(observer => {
      let payload = {};
      if (patientInfo) {
        payload['patientIds'] = [patientInfo.patientId]
      }
      this.http.post(`${environment['API_URL']}api/activity/getPatientTasks`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }
  public getPatientTaskClosed(patientInfo): Observable<any>{
    return new Observable(observer => {
      let payload = {
        page: 0,
        patientId: patientInfo.patientId
      };
      if (patientInfo) {
        payload['patientIds'] = [patientInfo.patientId]
      }
      this.http.post(`${environment['API_URL']}api/activity/getPatientClosedTasks`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }
  public generateOtpForPatientId(patientId): Observable<any>{
    let payload = {
      patientId: patientId
    }
    return new Observable(observer => {
      this.http.post(`${environment['API_URL']}api/schedules/generateOTPforPatientId`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }

  public sectionFocusEmitter(value){
    this.sectionFocusListener.next(value)
  }

  public closeWindow() {
    var win = this.openLocation("about:blank", "_self");
    win.close();
  }

  public setTaskViewSettings(settings) {
    if (settings) {
      this.taskViewSettings = settings;
    } else {
      let context = JSON.parse(sessionStorage.getItem(CTX));
      if (context && context.taskSettings) {
        this.taskViewSettings = context.taskSettings;
      } else {
        this.taskViewSettings = {
          scrollTime: 10,
          minimizeFulfilledSection: true
        }
      }
    }
  }

  public getTaskViewSettings() {
    return this.taskViewSettings
  }

  public setDefaultLanguage(languageList, selectedLangCode) {
    const lang = languageList.find(item => item.localeCode == selectedLangCode);
    if (lang) {
      this.changeLanguage(lang, true);
    }
  }

  public getMoment(val?, format?, strict?, timezone?) {
    let value = moment().locale('en')
    if (format) {
      value = moment(val, format, strict || false).locale('en');
    } else if(val) {
      value = moment(val).locale('en');
    }
    if (timezone) {
      value = value.tz(timezone, true);
    }
    return value;
  }
  public getRegistrationPayload() {
    return this.patientRegistrationPayload.payload;
  }
  public setRegistrationPayload(val) {
    this.patientRegistrationPayload = null;
  }

  private generateSignupData(payload) {
    return {
      patientName: {
        langArray: [{ langName: "English", code: "en", rtl: false, nameList: [{ title: "First name", code: "fName", desc: "Enter first name * ", mandatory: true, maxLength: 30, errMsg: "Please enter first name", regex: "[^a-zA-Z ]" }, { title: "Father Name", code: "mName", desc: "Enter Father Name  * ", mandatory: true, maxLength: 30, errMsg: "Please enter Father Name", regex: "[^a-zA-Z ]" }, { title: "Last name", code: "lName", desc: "Enter last name * ", mandatory: true, maxLength: 30, errMsg: "Please enter second name", regex: "[^a-zA-Z ]" }] }]
      },
      relationship: { hide: true },
      facility: {
        mandatory: false, hide: true
      }, gender: {
        mandatory: true
      }, dob: {
        mandatory: true, min: 1, max: 110, controls: { acceptCalendarType: "HIJRI" }
      }, mobile: {
        mandatory: true, maxLength: 10
      }, payergroup: {
        mandatory: true
      }, payer: {
        mandatory: false
      }, policyname: {
        mandatory: false
      }, email: {
        mandatory: true
      }, policyNumber: {
        mandatory: false
      }, membershipId: {
        mandatory: false
      },
      policyStartDate: { mandatory: false },
      policyEndDate: { mandatory: false },
      citizen: { mandatory: true, acceptVisitor: true },
      address: { hide: true, mandatory: false },
      address2: { hide: true },
      pinCode: { mandatory: false, hide: true },
      city: { mandatory: true },
      state: { mandatory: false },
      country: { mandatory: true },
      careOf: { mandatory: false, hide: true },
      employment: { mandatory: false },
      region: { mandatory: true, dependent: "city" },
      altIdView: { required: true, mandatoryAltIdCodes: { citizen: ["NATID"], nonCitizen: ["ALT1"] } },
      financialDetails: { required: true, allowMultiple: false },
      ...payload
    }
  }

  public setAppType(type: APPTYPE) {
    this.appType = type
    this.featureFlagsService.setAppType(type);
    this.cookie.set('APPTYPE', type);
  }

  public getAppType() {
    return this.appType;
  }

  public getPortalBasePath() {
    if (this.appType != 'webview') {
      return AppConstant.ROUTE_CRM;
    } else {
      return AppConstant.ROUTE_CRM;
    }
  }

  public openLocation(url, self?) {
    let tab = this.appType != 'webview' && !self ? '_blank' : '_self';
    let win;
    if (this.platform.IOS) {
     win = window['location'].href = url;
    } else {
      win = window.open(url, tab)
    }
    return win;
  }

  public getAutoSignon(): Observable<any> {
    return new Observable(observer => {
      try {
        // If running on localhost, always return false
        if (document.getElementsByTagName('base')[0].href.indexOf("localhost1:4") >= 0) {
          observer.next(false)
          observer.complete();
          return;
        }
        // Check for 'noautosignon' flag in the URL (query string or hash)
        // Usage: add '?noautosignon' or '&noautosignon' or '#noautosignon' to the URL to disable autosignon
        if (window && (window.location.search.includes('noautosignon') || window.location.hash.includes('noautosignon'))) {
          observer.next(false);
          observer.complete();
          return;
        }
      } catch (e) {
        // ignore
      }
      // Use sync access since data should already be loaded
      const data = this.getUpdateInfoSync('configuration');
      if (data && data['features'] && data['features'].externalInterface && data['features'].autoSignOn && !environment['DISABLESSOSIGNIN']) {
        observer.next(true)
        observer.complete();
      } else {
        observer.error()
      }
    })
  }
  public getPasswordPolicy() {
    return this.passwordPolicy
  }

  public checkPassword(condition): ValidatorFn {
    return (control: AbstractControl): any => {
      let string = control.value;
      let regex = {
        uppercase: /[A-Z]/g,
        lowercase: /[a-z]/g,
        number: /[0-9]/g,
        special: /[^A-Za-z0-9]/g,
      }
      let check = Object.keys(condition).map(key => {
        let cond = condition[key];
        let check = true;
        switch (key) {
          case 'length':
            check = string.length >= (cond['min'] || 0) && (!cond['max'] || string.length <= cond['max'])
            break;
          case 'uppercase':
          case 'lowercase':
          case 'number':
            let checkLength = cond['min'] || 1;
            check = !cond['enable'] || (regex[key].test(string) && string.match(regex[key]).length >= checkLength)
            break;
          case 'special':
            let checkLen = cond['min'] || 1;
            let spRegex = regex[key];
            if (cond['allowed'])
              check = !cond['enable'] || (regex[key].test(string) && string.match(regex[key]).length >= checkLen)
            break;
          case 'notin':
            check = !cond.values.includes(string);
            break;
          case 'norepeat':
            if (!cond['enable'] || cond['length'] <= 1) {
              check = true
            } else {
              let repeat = ''
              if (cond['length']) {
                repeat = new Array(cond[1] - 1).fill("\\1").join('');
              }
              if (repeat == '') {
                check = true;
              } else {
                let exp = new RegExp(`(.)${repeat}+`, 'g');
                check = !exp.test(string);
              }
            }
            break;
          default:
            check = true;
            break;
        }
        return { key, check };
      }).reduce((r, a) => {
        r[a['key']] = a['check'];
        return r;
      }, {})
      if (Object.keys(check).every(key => check[key])) return null
      return check;
    };
  }

  public getCurrencyForPayment() {
    return this.updateInfo['configuration']['currency'];
  }


  private getRouterBasedUpdate() {
    let contentHeaders = environment['RETRIEVE_LOCALSTORAGE'] ? JSON.parse(localStorage.getItem(AppConstant.CONTENT_HEADER)) : null;
    if (!contentHeaders) {
      contentHeaders = [{
        type: "configuration",
        version: "0"
      }, {
        type: "masters",
        version: "0"
      }, {
        type: "facilities",
        version: "0"
      }, {
        type: "facilityServices",
        version: "0"
      }, {
        type: "facilityProfiles",
        version: "0"
      }, {
        type: "practitionerProfiles",
        version: "0"
      }, {
        type: "directives",
        version: "0"
      }, {
        type: "labels",
        version: "0"
      }]
      if (this.router.url.includes(AppConstant.ROUTE_TASK) || this.router.url.includes(AppConstant.ROUTE_VACCINE) || this.router.url.includes(AppConstant.ROUTE_VIEW)) {
          contentHeaders = [{
            type: "configuration",
            version: "0"
          }, {
            type: "labels",
            version: "0"
          }, {
            type: "masters",
            version: "0"
          }]
      }
      if (this.router.url.includes(AppConstant.ROUTE_VISIT)) {
        contentHeaders = [{
          type: "configuration",
          version: "0"
        }, {
          type: "labels",
          version: "0"
        }, {
          type: "masters",
          version: "0"
        }, {
          type: "facilities",
          version: "0"
        }, {
          type: "facilityServices",
          version: "0"
        }]
      }
    }
    return contentHeaders
  }

  public getConfigurationInfo:Observable<any> = new Observable(observer =>{
    if (this.configLoaded) {
      observer.next(this.updateInfo['configuration'])
      observer.complete()
    } else {
      this.configLoadedSubject.subscribe(_ => {
        observer.next(this.updateInfo['configuration'])
        observer.complete()
      })
    }
  })

  public getMasterConfig: Observable<any> = new Observable(observer => {
    if (this.configLoaded) {
      observer.next(this.updateInfo['masters'])
      observer.complete()
    } else {
      this.configLoadedSubject.subscribe(_ => {
        observer.next(this.updateInfo['masters'])
        observer.complete()
      })
    }
  })

  getVisitRepoUrl(fid) {

    let url = environment['VISIT_API_URLS']?.[fid];
    if (!url)
      url = environment['VISIT_API_URL'];
    return url;
  }

  public syncPatientProfile() {
    this.getUserProfile().subscribe(data => {
      this.setSSOObjectOnUpdate(data);
      console.log('syncPatientProfile')
      this.userUpdateSubject.next(true)
    })

  }

  public fetchMessages(channelId, offset, apptRefNo, showTranscript: boolean = false) {
    const payload = {
      channelId: channelId,
      offset: offset,
      apptRefNo: apptRefNo,
      showTranscript: showTranscript
    };
    return new Observable(observer => {
      this.http.post(environment['API_URL'] + 'api/persons/getPatientAndPractitionerMessages', payload, { reportProgress: true }).subscribe(response => {
        if (response['status'] == 'SUCCESS')
          return observer.next(response);
        return observer.error();
      }, _ => observer.error());
    })
  }

  public pincheck(pincode, standalone?): Observable<any> {
    let payload = {
      pincode,
      locale: this.currentLanguage
    };
    let url = `${this.repoUrl}api/masters/pincheck`
    if (standalone)
      url = `${environment['VISIT_API_URL']}api/patientKiosk/pincheck`
    return Observable.create(observer => {
      this.http.post(url, payload).subscribe((data: any) => {
        observer.next(data);
        observer.complete();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getResourceListingType(forceResourceListing:boolean = false): 'API' | 'NORMAL'{
    if (this.pxAppSettings && this.pxAppSettings.resourceListing && this.pxAppSettings.resourceListing == 'API' && (forceResourceListing)) {
      return 'API';
    } else {
      return 'NORMAL';
      // return 'API';
    }
  }

  public getPatientFacilities(publish: boolean = true) {
    this.http.get(`${environment['API_URL']}${AppConstant.API_PERSONS}/facilitiesforpatient`, {reportProgress: true}).subscribe(data => {
      this.setPatientFacilities(data['data'], publish);
    }, error => {
      this.getErrorMessage(error);
    })
  }

  private getResourceList(): Observable<any> {
    let mobileNum = this.getPersonMobile();
    let payload = {
      facilityId: this.facilityMaster.facilityArray,
      mobileNum: mobileNum
    }
    return new Observable(observer => {
      this.http.post(`${environment['API_URL']}${AppConstant.API_CONTENT}/practitionersforfacility`,payload, { reportProgress: true }).subscribe(data => {
        observer.next(data['data']);
      }, error => {
        this.getErrorMessage(error);
      })
    })
  }

  private setPatientFacilities(data, publish) {
    let groupFacility = _.values(_.groupBy(data, 'facilityId'));
    let updatedFacility = [];
    let facilityProfile = [];
    groupFacility.map((f: any) => {
      let sort = f.sort((a: any, b: any) => new Date(b['lastVisitDate']).getTime() - new Date(a['lastVisitDate']).getTime());
      if (sort) {
        updatedFacility.push(sort[0]);
        facilityProfile.push({
          facilityId: sort[0]['facilityId'],
          profile: sort[0]['profiles']
        })
      }
    })
    this.facilityMaster = {
      actualData: data,
      facilityList: updatedFacility,
      facilityProfile: facilityProfile,
      facilityArray: updatedFacility.map(f => f.facilityId)
    }
    // console.log("facilityMaster", this.facilityMaster)
    this.getResourceList().subscribe(resourceData => {
      this.resourceMaster = resourceData;
      this.resourceMaster['facilityServices'] = resourceData['facilities'].map(fac => {
        fac.specialities = fac.specialities.map(spec => {
          let pracList = fac.practitioners.filter(prac => {
            return prac.specialityId === spec.specialityId;
          });
          let videoPrac = fac.practitioners.filter(prac => {
            return prac.specialityId == spec.specialityId && (prac.schedulerControls['consultType'] == 'HOSPVIDEO' || prac.schedulerControls['consultType'] == 'VIDEO');
          })
          let hospPrac = fac.practitioners.filter(prac => {
            return prac.specialityId == spec.specialityId && (prac.schedulerControls['consultType'] == 'HOSPVIDEO' || prac.schedulerControls['consultType'] != 'VIDEO');
          })
          return { ...spec, pracList: pracList, pracCount: pracList.length, VIDEO: videoPrac, VIDEOCOUNT: videoPrac.length, HOSPITAL: hospPrac, HOSPITALCOUNT: hospPrac.length }
        })
        return fac;
      });
      this.resourceMaster['facilities'] = this.facilityMaster['facilityList']

      this.featureFlagsService.initFacility({facilities: this.resourceMaster['facilities']})
      // console.log("===== resourceMaster['facilities'] ======", this.resourceMaster)
    })
  }

  public getAttributeForListingType(type: 'facilities' | 'facilityServices' | 'specialities' | 'facList', forceResourceListing:boolean = false) {
    switch (type) {
      case 'facilities':
        if (this.getResourceListingType(forceResourceListing) == 'API') {
          return this.resourceMaster;
        } else {
          return this.updateInfo['facilities'];
          // return this.updateInfo['facilityServices'];
        }
        break;
      case 'facilityServices':
        if (this.getResourceListingType(forceResourceListing) == 'API') {
          return { facilities: this.resourceMaster['facilityServices']};
        } else {
          return this.updateInfo['facilityServices'];
        }
        break;
      case 'specialities':
        if (this.getResourceListingType(forceResourceListing) == 'API') {
          return this.resourceMaster['facilityServices'];
        } else {
          return this.updateInfo['facilityServices']['facilities'];
        }
        break;
      case 'facList':
        if (this.getResourceListingType(forceResourceListing) == 'API') {
          return this.resourceMaster['facilities'];
        } else {
          return this.updateInfo['facilities']['facilities'];
        }
        break;
    }
  }
  public getPatientReportHistory(patientId, eventCode) {
    const payload = {
      patientId: patientId,
      eventCode: eventCode
    }
    return new Observable(observer => {

      this.http.post(`${this.repoUrl}api/visits/getReportComponentHistory`, payload).subscribe(response => {
        if (response['status'] == 'SUCCESS')
          return observer.next(response['data']);
        return observer.error();
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    })
  }

  public updatePxAppPermissions(permission) {
    if (permission) {
      this.pxAppSettings = permission
      this.combinedAppPermissions['BOOKTHROUGHDISCOVERY'] = permission.appointmentWithDiscovery;
      this.combinedAppPermissions['PATIENTSFFROMPERSON'] = permission.groupByPersonId;
      this.combinedAppPermissions['GROUPPATIENTSBYFACILITY'] = permission.groupPatientsByFacility;
      this.combinedAppPermissions['FIRSTTIMEINVITE'] = permission.firstTimeInviteView;
      this.combinedAppPermissions['DISABLEFACILITYCONTEXTFORREG'] = permission.disableFacilityContextForReg;
      this.combinedAppPermissions['ENABLECAREPLAN'] = permission.enableCarePlan;
      this.combinedAppPermissions['FILESELECTIONWIDTH'] = permission.fileUploadWidth;
      this.combinedAppPermissions['FILESELECTIONHEIGHT'] = permission.fileUploadHeight;
      this.combinedAppPermissions['DISABLENUMBERCONVERSION'] = permission.disableNumberConversion;
      this.combinedAppPermissions['PASSBASEDLOGON'] = permission.enablePasswordBasedLogon;
      this.combinedAppPermissions['SKIPOTPVALIDATION'] = permission.skipOTPValidation;
      this.combinedAppPermissions['MINPINLENGTH'] = permission.minPinLength;
      this.combinedAppPermissions['MAXPINLENGTH'] = permission.maxPinLength;
      this.combinedAppPermissions['RESRTRICTPRACTITIONERSHARING'] = permission.restrictPractitionerForSharingDocs;
      this.combinedAppPermissions['ECMAXSERVICEDURATION'] = permission.expressClinicMaxApptDur;
      this.combinedAppPermissions['GROUPFACILITYFORVC'] = true;
      this.combinedAppPermissions['HIDEDRPROFILE'] = permission.hideDoctorProfile;
      this.combinedAppPermissions['VISITFEEDBACK']= permission.feedbackByVisitsYn;
      // this.combinedAppPermissions['HIDEPACKAGEFILTER'] = environment.HIDEPACKAGEFILTER;
      this.combinedAppPermissions['SHOWHOMESERVICEWITHLOC'] = permission.show_home_services;
      this.combinedAppPermissions['ENABLEHOMECAREWITHOUTLOC'] = permission.show_home_services_artimes;
      this.combinedAppPermissions['SHOWMYREQUESTS'] = !permission.hideServiceRequest;
      this.combinedAppPermissions['ENABLEEXPRESSCLINIC'] = permission.enableExpressClinicYn == 'Y';
      this.combinedAppPermissions['ENABLEONSPOTCONSULT'] = permission.hasOnspotConsultation;
      this.combinedAppPermissions['CANVIEWAPPONBIOMETRICFAILURE'] = permission.preventCloseAppOnBiometricFailure;
      this.combinedAppPermissions['CANVERIFYTHROUBHBIOMETRIC'] = permission.enableBiometricAuth;
      this.combinedAppPermissions['ENABLEONSPOTCONSULT'] = permission.onSpotConsultationYn == 'Y';
      this.combinedAppPermissions['ENABLEAPPTOUR'] = permission.enableAppTour;
      this.combinedAppPermissions['ENABLEONLINECONSULT'] = permission.enableOnlineConsultation == 'Y';
      this.combinedAppPermissions['ENABLEPACKAGES'] = permission.enablePackages == 'Y';
      this.combinedAppPermissions['ENABLEEMERGENCY'] = permission.enableEmergency == 'Y' ;
      this.combinedAppPermissions['ENABLEPHONECONSULT'] = permission.enablePhoneConsult == 'Y';
      this.combinedAppPermissions['ENABLEPAYONRECENTBILL'] = permission.enablePayRecentBill == 'Y';
      this.combinedAppPermissions['ENABLEFEEDBACKONHOME'] = permission.hideFeedbackOnHome !=true;
      this.combinedAppPermissions['ENBALEPRINTINPRESCRIPTION'] = permission.enablePrintPrescriptionYn =='Y';
      this.combinedAppPermissions['ENBALEMYALERTS'] = permission.disableAlertsYn !='Y';
      this.combinedAppPermissions['DISABLERECENTLYCONSULTED'] = permission.disablerecentlyconsulted;
      this.combinedAppPermissions['DISPLAYPRICEINFO'] =  permission.displayPriceInfo != 'N';
      this.combinedAppPermissions['ENABLESUMMARYINVIEW'] = !permission.hideHrSummary;
      this.combinedAppPermissions['IGNORESUMMARYPAGE'] = permission.ignoreHrSummaryPage;
      this.combinedAppPermissions['ENABLEAPPTREQUEST'] = permission.enableApptRequest == 'Y';
      this.combinedAppPermissions['SHOWNUHDEEKPOINTS'] = permission.showNuhdeekPointsOnAccount == 'Y';
      this.combinedAppPermissions['MINIMUMEXCHANGEELIGIBLENUHDEEKPOINTS'] = permission.minimumExchangeEligibleNuhdeekPoints
      this.combinedAppPermissions['EXCHANGECOUPONSLINK'] = permission.exchangeCouponsLink

      this.combinedAppPermissions['ENABLEUPCOMING'] = permission.enableUpcoming == 'Y';
      this.combinedAppPermissions['ENABLECANCELLED'] = permission.enableCancelApptList == 'Y';
      this.combinedAppPermissions['ENABLECOMPLETED'] = permission.enableCompletedApptList == 'Y';
      this.combinedAppPermissions['ENABLEINPROCESS'] = permission.enableInProgressApptList == 'Y';

      this.combinedAppPermissions['QUICKVIEWFORCLINIC'] = permission.enableQuickViewForClinic == 'Y';
      this.combinedAppPermissions['QUICKVIEWFORVC']= permission.enableQuickViewForVC == 'Y';
      this.combinedAppPermissions['ENABLEPAYONCONSULTFORINS'] = permission.enablePayOnConsultForInsurance =='Y';
      this.combinedAppPermissions['SHOWAPPLEPAY'] = !permission.hideApplePay;
      this.combinedAppPermissions['HIDETELECONSULTATIONTC']= permission.hideTeleConsultationTC == 'Y';
      this.combinedAppPermissions['WHATSAPPLINK'] = permission.whatsAppLink;
      this.combinedAppPermissions['ENABLEREQUESTCOMPLAINT'] = permission.enableRequestComplaintUI == 'Y';
      this.combinedAppPermissions['HIDESERVICEREQUEST'] = permission.hideServiceRequest == 'Y';
      this.combinedAppPermissions['ENABLELINKPATIENT']= permission.enableLinkPatient == 'Y';
      //Health records in patient view
      this.combinedAppPermissions['ENABLESUMMARYINVIEW'] = permission.hideSummary != 'Y';
      this.combinedAppPermissions['ENABLEVISITSINVIEW'] = permission.hideVisits != 'Y';
      this.combinedAppPermissions['ENABLEREPORTSINVIEW'] = permission.hideReports != 'Y';
      this.combinedAppPermissions['ENABLEPRESCRIPTIONINVIEW'] = permission.hidePrescription != 'Y';
      this.combinedAppPermissions['ENABLEBILLSINVIEW'] = permission.hideBills != 'Y';
      this.combinedAppPermissions['ENABLEPARAMETERINVIEW'] = permission.enableParameter == 'Y';
      this.combinedAppPermissions['ENABLETASKSINVIEW'] = permission.enableTask == 'Y';
      //Health records in detail view
      this.combinedAppPermissions['ENABLESUMMARYINDTLS'] = permission.hideSummary != 'Y';
      this.combinedAppPermissions['ENABLEVISITSINDTLS'] = permission.hideVisits != 'Y';
      this.combinedAppPermissions['ENABLEREPORTSINDTLS'] = permission.hideReports != 'Y';
      this.combinedAppPermissions['ENABLEPRESCRIPTIONINDTLS'] = permission.hidePrescription != 'Y';
      this.combinedAppPermissions['ENABLEBILLINDTLS'] = permission.hideBills != 'Y';
      this.combinedAppPermissions['ENABLEPARAMETERINDTLS'] = permission.enableParameter == 'Y';
      this.combinedAppPermissions['ENABLEPATIENTCALANDARINDTLS'] = permission.enableTask == 'Y';

      this.combinedAppPermissions['ENABLEQUEUENO'] = permission.enableQueueNoInAppt =='Y';
      this.combinedAppPermissions['ENABLEPROMO'] = permission.enablePromoYn == 'Y';
      this.combinedAppPermissions['ENABLECOUPON'] = permission.enableCouponYn =='Y';
      this.combinedAppPermissions['SHOWAVAILABLEPROMO'] = permission.showAvailPromoYn =='Y';
      this.combinedAppPermissions['ORDERPRESCRIPTION'] = permission.orderFromPharmacy =='Y';
      this.combinedAppPermissions['ENABLEDELETEACCFORIOS'] = permission.enableDeleteAccountForIOS == 'Y';
      this.combinedAppPermissions['ENABLEDELETEACCFORANDROID'] = permission.enableDeleteAccountForAndroid == 'Y';
      this.combinedAppPermissions['DELETEACCOUNTTHROUGHWEB'] = permission.deleteAccountThroughWeb;
      this.combinedAppPermissions['ENABLEREFUNDPOLICY'] = permission.enableRefundPolicy =='Y';
      this.combinedAppPermissions['ENABLEVCREJOINOUTERTIME'] = permission.disableVCRejoinOuterTime !='Y';
      this.combinedAppPermissions['ENABLEONSPOTREJOINOUTERTIME'] = permission.disableOnspotRejoinOuterTime !='Y';
      this.combinedAppPermissions['SEPERATEVIEWFORPRACTSPEC'] = permission.seperateViewForPractSpec =='Y';
      this.combinedAppPermissions['EXPRESSCLINICGROUPNEARCOUNT'] = permission.expressClinicGroupNearCount || 3;
      this.combinedAppPermissions['GROUPEXPRESSCLINICBYDISTANCE'] = permission.groupExpressClinicByLocation || true;
      this.combinedAppPermissions['CANENABLELINKPATIENTONACCOUNTTAB'] = permission.canEnableLinkPatientOnAccountTab == 'Y';
      this.combinedAppPermissions['CANENABLEMANAGEINSURNACEPOLICIES'] = permission.canEnableManageInsurancePolicies == 'Y';
      this.combinedAppPermissions['CANENABLEVIEWAPPOINTMENT'] = permission.canEnableViewAppointment == 'Y';
      this.combinedAppPermissions['SHOWPRACTITIONERCHARGE'] = permission.showPractitionerCharge == 'Y';
      //added to enable insurance payment for appointment booking
      this.combinedAppPermissions['CHECKINSAPPLICABILITY'] = permission.isInsApplicableForAppt;
      this.combinedAppPermissions['SHOWMYDEVICEINACCOUNTTAB'] = permission.showMyDevicInAccountTab;
      this.combinedAppPermissions['SHOWDAYSBASEDONSCHEDULE'] = permission.showDaysBasedOnSchedule;
      this.combinedAppPermissions['AUTOSELFWHENNOSELF'] = permission.autoSelfWhenNoSelf == 'Y';
      this.combinedAppPermissions['CANHIDEREGISTER'] = permission.canHideRegister;
      this.combinedAppPermissions['LINKEDPERSONMAXCOUNT'] = permission.linkedPersonMaxCount;
      this.combinedAppPermissions['DOCSHAREASPDF'] = permission.docShareASPdf || true;
      this.combinedAppPermissions['HCMAXSERVICEDURATION'] = permission.homeCareClinicMaxApptDur;
      this.combinedAppPermissions['ENABLEFLOWSHEET'] = permission.enableFlowsheet == 'Y'
      this.combinedAppPermissions['SHOWLIVENOTIFICATION'] = permission.showLiveNotification == 'Y'
      this.combinedAppPermissions['ENABLEREQONLYPACKAGE'] = permission.enableReqOnlyPackage == 'Y';
      this.combinedAppPermissions['USEFACILITYWITHOUTPRACTAVAILABILITY'] = permission.allowFacilityViewWithoutPractitioner == 'Y';
      this.combinedAppPermissions['CANSHOWINSALERTINAPTPREVIEW'] = permission.showInsAlertInAptPreview == 'Y';
      this.combinedAppPermissions['ENABLECONFIGBASEDDEFAULTLANG'] = permission.enableConfigBasedDefaultLang == 'Y';
      this.combinedAppPermissions['DISABLEPAYBEFORECHECKINTIME'] = permission.disablePayBeforeCheckinTime;
      this.combinedAppPermissions['EXPRESSCLINICPERPAGECOUNT'] = permission.expressClinicPerPagecount || null;
      this.combinedAppPermissions['CLEARDEFAULTGENDERONREGISTER'] = permission.clearDefaultGenderOnRegister;
      this.combinedAppPermissions['CLEARDEFAULTDOBONREGISTER'] = permission.clearDefaultDobOnRegister;
      this.combinedAppPermissions['DISABLECOUNTRYMODALIFONECNTRY'] = permission.disableChangeCountryIfOneCountry;
      this.combinedAppPermissions['ENABLECATEGORYBASEDCLINICAPPT'] = permission.enableCategoryBasedClinicAppt;
      this.combinedAppPermissions['CLINICAPPTRECENTCONSULTRESPONSELIMIT'] = permission.clinicApptRecentConsultResponseLimit;
      this.combinedAppPermissions['HIDEHHCNAVFROMPACKGE'] = permission.hideHHCNavFromPackage == 'Y';

       //ONSPOT OVERLAY FLAG
       this.combinedAppPermissions['ENABLECHECKAPPTOVERLAPFORPATIENT'] = permission.enableCheckApptOverlapForPatient == 'Y';
       this.combinedAppPermissions['ENABLERECENTLYCONSULTEDVIEW'] = permission.disableRecentlyConsultedView != 'Y';

      //OTP TIMER FLAG
      this.combinedAppPermissions['HIDEFORGOTPWDRESENDOTP'] = permission.hideForgotPwdResendOtp == 'Y';
      this.combinedAppPermissions['HIDESIGNUPRESENDOTP'] = permission.hideSignupResendOtp == 'Y';
      this.combinedAppPermissions['DISABLECOUNTRYCODEONCHANGENUMBER'] = permission.disableCountryCodeOnChangeNumber == 'Y';
      this.combinedAppPermissions['SHOWNPSRATINGINPXPORTAL'] = permission.showNpsRatingInPXPortal == 'Y';

      this.combinedAppPermissions['CANPAYLATERFORINSURANCEHOSP'] = permission.canPaylaterForInsuranceHosp == 'Y';
      this.combinedAppPermissions['RESCTICTPAYLATERFORINSURANCEVIDEO'] = permission.restrictPaylaterForInsuranceVideo == 'Y';
      this.combinedAppPermissions['ONSPOTWITHSPECIALITY'] = permission.enableOnspotWithSpeciality == 'Y';
      this.combinedAppPermissions['SHOWONSPOTSPECGROUP'] = permission.hideOnspotSpecGroup !== 'Y';
      this.combinedAppPermissions['ENABLEPATIENTSTATUSCHECK'] = permission.enablePatientStatusCheck == 'Y';
      this.combinedAppPermissions['ENABLEPKGDESCRIPTION'] = permission.enablePkgDescription == 'Y';
      this.combinedAppPermissions['PKGDESCRIPTIONCHARLIMITWITHOUTEXPAND'] = permission.pkgDescriptionCharLimitWithoutExpand || 100;
    }
  }

  public canViewOption(optionName: PERMISSIONSAVAILABLE) {
    return this.combinedAppPermissions[optionName];
  }

  public getBookingConcept(): BookAppointmentConcept {
    if (this.canViewOption('BOOKTHROUGHDISCOVERY')) {
      return 'FACILITYUNSPECIFIC'
    } else {
      return 'FACILITYSPECIFIC'
    }
  }
  public getCurrentLanguage() {
    return this.currentLanguage;
  }

  public setCoupons(data){
    this.setStorage(AppConstant.PX_COUPONS, JSON.stringify(data));
  }

  public clearCoupons() {
    this.setStorage(AppConstant.PX_COUPONS, null);
  }

  public getCoupons(): Observable<any>{
    return Observable.create(observer => {
      let coupons = JSON.parse(sessionStorage.getItem(AppConstant.PX_COUPONS));
      observer.next(coupons);
    })
  }

  public isLoggedIn() {
    let token = this.cookie.check(AppConstant.USER_TOKEN);
    let time = this.cookie.checkTime();
    return token && time;
  }

  public isNpsModalDisplayed() {
    return this.npsModalDisplayed
  }
  public setNpsModalDisplayed() {
    this.npsModalDisplayed = true
  }

  public getPolicyDetails(data) {
    let payload = data.map(d => {
      d.version = 'v1';
      return d;
    })
    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/schedules/getPatientInsuranceDetails`, payload, { reportProgress: false }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {

      })
    })
  }

  public getCountryObj(cc, ciso = null) {
    let countryDetail = ALL_COUNTRIES.filter(c => c[2] == cc);
    console.log('country info obj---', countryDetail, cc)
    if (cc) {
      countryDetail = ALL_COUNTRIES.filter(c => c[2] == cc);
    }
    if (ciso) {
      countryDetail = ALL_COUNTRIES.filter(c => c[1] == ciso);
    }
    if (countryDetail.length > 1 && cc) {
      countryDetail.find(c => c[1] == cc)
    }
    return countryDetail;
  }
  public getPatient(uhid, isPatientDisabled: boolean = false): Observable<any> {
    let payload = {
      patientId: uhid,
      personId: this.getPersonId(),
      isActivePatient: isPatientDisabled ? 'N' : 'Y'
    }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/persons/getPatientDemographics`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
      })
    });
  }

  public updateFinancialStatus(payload): Observable<any> {
    return Observable.create(observer => {
      this.http.post(`${this.getRepoUrl()}api/schedules/changeFinancialStatus`, payload, { reportProgress: false }).subscribe((data) => {
        observer.next(data);
      }, error => {
        observer.error(error);
      })
    });
  }

  public getCoutryCode(phoneNumberStr) {
    var phoneUtil = PhoneNumberUtil.getInstance()
    try {
      var numberProto = phoneUtil.parse(phoneNumberStr, "")
      console.log('country code log---', numberProto, numberProto['values_']['1'])
      return numberProto['values_']
    } catch (e) {
      console.log('country code error log---', e)
    }
  }

  public sendEnquiry(payload) {
    return new Observable(observer => {
      this.http.post(`${environment['API_URL']}api/services/enquiry`, payload, { reportProgress: true })
        .subscribe({
          next: (data) => {
            observer.next(data['data']);
          },
          error: (error) => {
            observer.error(error);
          }
        })
    })
  }

  public setFinancialStatusUpdated(status){
    this.isFinancialStatusUpdated=status;
  }

  public getFinancialStatusUpdated(){
    return this.isFinancialStatusUpdated;
  }

  public getAvailableDaysForPract(payload): Observable<any> {
    payload.isBackgroundProcess = true;
    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/schedules/getAvailableCountForPractitioner`, payload, { reportProgress: false }).subscribe(data => {
        observer.next(data['data']);
      }, error => {
        observer.error();
      })
    })
  }

  public getAwaitingActionList(inparam, isBackground?): Observable<any> {
    let payload = {
      'personId': this.getPersonId(),
      isBackgroundProcess: isBackground,
      ...inparam
    }
    return new Observable(observer => {
      if (inparam['patientIds'].length == 0) {
        observer.next([]);
        observer.complete();
        return;
      }
      
      this.http.post(`${environment['API_URL']}api/persons/getAwaitingActionList`, payload, { reportProgress: true }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        observer.error()
        observer.complete();
      })
    })
  }

  public getPasswordValidation(): Array<any> {
    const isExternalInterface = this.isExtidLogin;
    let validator = []
    let minLength = isExternalInterface ? null : 4;
    let maxLength = isExternalInterface ? null : 4;
    let pattern = this.passwordRegex
    if (!pattern)
      pattern = isExternalInterface ? "^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$" : "^[0-9]*$"
    if (this.minPasswordLength) {
      minLength = this.minPasswordLength
    }
    if (this.maxPasswordLength) {
      maxLength = this.maxPasswordLength
    }
    validator.push(PasswordValidator(pattern, minLength, maxLength))
    return validator
  }

  public getQueueNo(body): Observable<any> {
    // const payload = { "apptRefNo": "171783", "password": "8weJEmWB", "linkType": "P" }
    return Observable.create(observer => {
      this.http.post(`${this.getRepoUrl()}api/patients/getQueueNo`, body, { reportProgress: false }).subscribe((data) => {
        observer.next(data);
      }, error => {
        observer.error(this.getErrorMessage(error));
        // observer.next({type: 'LOGIN'})
      })
    });
  }

  public getRestrictionForPatients(payload): Observable<any> {

    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/schedules/checkGenderRestrictionForPatients`, payload, { reportProgress: false }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {

      })
    })
  }

  public showNpsRatingControl(): Observable<any> {
    return new Observable(observer => {
      let payload = {
        source: 'PXAPP',
        personId: this.getPersonId()
      }
      this.http.post(`${environment['API_URL']}api/persons/checkNpsRating`, payload, { reportProgress: true }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        console.log(error)
      })
    })
  }
  public storeNpsRating(action, values, options): Observable<any> {
    return new Observable(observer => {
      let payload = {
        source: 'PXPORTAL',
        action: action,
        values: values,
        options: options
      }
      console.log('payload', payload)
      this.http.post(`${environment['API_URL']}api/persons/postNpsRating`, payload, { reportProgress: true }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {
        console.log(error)
      })
    })
  }
  public setNormalcyInd(data) {
    this.normalcyInds = data;
  }
  public getNormalcyInd() {
    return this.normalcyInds && this.normalcyInds.length > 0 ? this.normalcyInds : DEFAULTNORMALCY;
  }

   public setMasters() {
     this.getMasterConfig.subscribe(data => {
      console.log('masters data', data)
     let normalcyMaster = data.list.find(d => {
     return d.domain === 'NORMALIND'
     });
     if (normalcyMaster) {
     this.setNormalcyInd(normalcyMaster.codes)
     }
     let packageClassificationMaster = data.list.find(master => master.domain == 'PACKAGESPECIALITY');
     console.info('packageClassificationMaster', packageClassificationMaster, data)
     if (packageClassificationMaster) {
     this.setPackageClassification(packageClassificationMaster.codes)
     }
     })   
   
   }
      
   public setPackageClassification(data) {
     this.packageClassificationMaster = data || [];
     console.info('packageClassificationMaster', data)
     // this.permission.setHealthPackageClassificationPermission(this.packageClassificationMaster)
     }
    
     public getPackageClassification() {
     return _.cloneDeep(this.packageClassificationMaster)
  }

  public setPackageClassificationType(data) {
    this.packageClassificationType = data;
  }

  public getPackageClassificationType() {
    return this.packageClassificationType;
  }

  private setDefaultTimezone(timezone) {
    if (!this.timezones) this.timezones = {}
    this.timezones['DEFAULTTIMEZONE'] = { zoneName: timezone }
  }

  private setFacilitiesTimezone(facilities) {
    console.log('setFacilitiesTimezone', facilities)
    if (!this.timezones) this.timezones = {}
    facilities.forEach(facility => {
      let timezone = facility?.facilityControls?.schedulingRules?.defaultTimezone;
      if (timezone) {
        this.timezones[facility.facilityId] = { zoneName: timezone }
      }
      let offset = facility?.facilityControls?.schedulingRules?.offsetTimeForDirectBooking
      if (offset) {
        this.offsets[facility.facilityId] = offset
      }
    })
  }

  public getFacilityTimezone(facilityId) {
    console.log('Guess timezone', moment.tz.guess())
    if (this.timezones && facilityId && this.timezones[facilityId] && this.timezones[facilityId].zoneName) {
      return this.timezones[facilityId].zoneName
    } else if (this.timezones && this.timezones['DEFAULTTIMEZONE']) {
      return this.timezones['DEFAULTTIMEZONE'].zoneName
    } else {
      return moment.tz.guess()
    }
  }

  public setDashboardConfig(data) {
    this.dashboardConfig = data
  }

  public getDashboardConfig() {
    return this.dashboardConfig;
  }

  public getDirectOffset(facilityId) {
    return this.offsets[facilityId] || 0
  }

  public setPaymentIntervalForReference(data) {
    this.paymentIntervalForReference = data;
  }

  public checkTimeExpiry(expire){
    if(this.getMoment().isBefore(expire)){
      return true;
    }
    else {
      return false;
    }
  }

  public getPaymentIntervalForReference() {
    return this.paymentIntervalForReference;
  }

  public getInsuranceDemographics(idNumber): Observable<any> {
    let payload = {
      idNumber: idNumber
    }
    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/outpatients/getDemographicsFromInsurance`, payload, { reportProgress: false }).subscribe(data => {
        observer.next(data['data']);
        observer.complete();
      }, error => {

      })
    })
  }

    public getGroupedConcepts(service, applicableServices): { concept: any[], applicableFacilities: any[], firstService: any} {
    let groupedConcepts = []
    let applicableFacilities = []
    let allPackages = this.getAllDirectives()
    let directive = this.findDirective(allPackages, service)
    let firstService;
    if (directive) {
      let conceptCodes = applicableServices.filter(service => {
        let directiveCode = service.directiveCode || service.serviceInd
        return directiveCode === directive.code
      }).map(service => service.conceptCode || service.serviceCode);
      switch (directive.serviceAppointmentBookingGrp) {
        case 'CS':
          let concepts = directive.concepts.filter(concept => conceptCodes.includes(concept.code))
          groupedConcepts = concepts;
          firstService=groupedConcepts.find(con=>con.code==service.conceptCode)
          applicableFacilities = firstService? firstService.facilities: concepts[0].facilities;
          break;
        case 'CET':
          let conceptCodeCET = service.conceptCode || service.serviceCode;
          let conceptCET = directive.concepts.find(con => con.code === conceptCodeCET);
          let careElementType = conceptCET.careElementType
          let conceptsCET = directive.concepts.filter(concept => concept.careElementType === careElementType && conceptCodes.includes(concept.code));
          groupedConcepts = conceptsCET;
          firstService=groupedConcepts.find(con=>con.code==service.conceptCode)
          applicableFacilities = firstService? firstService.facilities: conceptsCET[0].facilities;
          break;
        default:
          let conceptCode = service.conceptCode || service.serviceCode;
          let concept = directive.concepts.find(con => con.code === conceptCode);
          groupedConcepts = [concept];
          applicableFacilities = concept.facilities;
          break;
      }
    }
    let response = { concept: groupedConcepts, applicableFacilities: applicableFacilities, firstService: service }
    return response
  }

    public findDirective(allPackages, key) {
    // console.log('findDirective', allPackages, 'keyss>>', key);
    let directiveCode = key.directiveCode || key.packageCode;
    if (directiveCode) {
      let directive = this.findDirectiveByDirectiveCode(allPackages, directiveCode)
      return directive
    }
    let conceptCode = key.conceptCode
    if (conceptCode) {
      let concept = this.allPackageConcepts.find(con => con.code === conceptCode)
      if (concept) {
        let directiveCode = concept?._directiveRef?.code
        if (directiveCode) {
          let directive = this.findDirectiveByDirectiveCode(allPackages, directiveCode)
          return directive
        }
      }
    }
    return null;
  }

  private findDirectiveByDirectiveCode(allPackages, directiveCode) {
    let directive = allPackages.find(dir => dir.code === directiveCode)
    return directive
  }

  public getPatientByPatientId(patientId, facilityId?) {
    console.log('linked patients', this.userInfo.linkedPatients);
    let patients = this.userInfo.linkedPatients;
    if (patients?.length > 0) {
      let patient = patients.find(pat => pat.uhid == patientId)
      return patient;
    } else {
      return null;
    }
  }

  initDataDog(config, settings) {
    // let config = environment['DATADOG_CONFIG'];
    config['version'] =  APP_VERSION;
    // config['defaultPrivacyLevel'] = privacy;
    datadogRum.init(config);
    if (settings?.browserLogs) {
      let cfg = settings?.browserLogs
      cfg.version = APP_VERSION
      datadogLogs.init(cfg)
      console.log('datadogLogs init', cfg)
    }

  }

  public getRegistrationMasters(masterCode): Observable<any> {
    let payload = {
      masterCode: masterCode
    }
    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/masters/getPatRegistrationMasters`, payload, { reportProgress: false }).subscribe((data) => {
        observer.next(data['data']);
        observer.complete()
      }, error => {
        observer.error(error);
      })
    });
  }

  public getAllUnbilledEncounters(patientIds: string, key: string, isBackgroundProcess:boolean = false): Observable<any> {
      const payload = {
        patientIds: patientIds,
        facilityId: null,
        key: key,
        locale: this.getCurrentLanguage(),
        entityId: 'ALNAHDI',
        isBackgroundProcess: isBackgroundProcess,
      }
      return new Observable(observer => {
        this.http.post(`${this.getRepoUrl()}api/schedules/getAllUnbilledEncounters`, payload, { reportProgress: false }).subscribe(data => {
          if(data && data['data'])
            observer.next(data['data']);
            observer.complete();
        }, error => {
          observer.error(error);
          observer.complete();
        })
      })
    }

  public setApptReqDermaServices(services){
    this.apptReqDermaServices = services;
  }

  public setApptReqConsultServices(services){
    this.apptReqConsultServices = services;
  }

  public setRestrictApprovalCode(restrictApprovalCodes){
    this.restrictApprovalCode=restrictApprovalCodes
  }

  public setRestrictApprovalStatusCode(restrictApprovalStatusCodes){
    this.restrictApprovalStatusCode=restrictApprovalStatusCodes;
  }

  public getRestrictApprovalCode(){
    return this.restrictApprovalCode || [];
  }
  public getRestrictApprovalStatusCode(){
    return this.restrictApprovalStatusCode || [];
  }

  public getErVisits(param,isBackgroundProcess:boolean = false): Observable<any> {
    const payload = {
      ...param,
      locale: this.getCurrentLanguage(),
      isBackgroundProcess: isBackgroundProcess,
    }
    console.log('payload', payload);
    return new Observable(observer => {
      this.http.post(`${this.getRepoUrl()}api/schedules/getVisitsBySpeciality`, payload, { reportProgress: false }).subscribe(data => {
        if(data && data['data'])
          observer.next(data['data']);
          observer.complete();
      }, error => {
        observer.error(error);
        observer.complete();
      })
    })
  }

    setUnbilledService(data) {
      this.doctorRecServiceList = data;
    }

    public setDirectivesSplitIntosubdirectiveCategory(data) {
      this.directivesSplitIntosubdirectiveCategory = data;
    }

    public getDirectivesSplitIntosubdirectiveCategory() {
      return this.directivesSplitIntosubdirectiveCategory;
    }
  
    public getUnbilledService() {
      return this.doctorRecServiceList;
    }
  
    public setEncounterList(data) {
      this.encounterList = data
    } 
  
    public getEncounterList() {
      return this.encounterList || [];
    } 

  public setUserInfoForPackageLink(userInfo, token, repoInfo) {
    this.userInfo = {
      personDetails: {
        personId: userInfo.person_id,
        personName: userInfo.person_name,
      },
      repoDetails: repoInfo,
      credentials: token
    }
  }

  public getPackageFromUpdateCheck(packageCode: string) {
    const data = this.getUpdateInfoSync('directives');
    if (data && data.userDefined) {
      const directives = data.userDefined.filter(def => def.isPackageApplicable == 'Y');
      let concept
      directives.forEach(directive => {
        if(!concept) {
          let c = directive.concepts.find(c => c.code == packageCode);
          if(c && c['packageDtls']) {
            c['directiveCode'] = directive.code;
            c['directiveGroup'] = directive.directiveGroup;
            c['directiveDesc'] = directive.name;
            concept = c;
          }
        }
      });
      console.log('concept', concept);
      return concept;
    }
  }

  public getAllPractitioners(getUniquePractitioners: boolean = false, getFromBookingEnabledFacility: boolean = false, consultType: Array<any> = null, selectedSpeciality: string = null): Array<any> {
    let allFacilities = this.getAttributeForListingType('facilityServices', true)?.facilities
    if (getFromBookingEnabledFacility) {
      let facinfo = this.getAttributeForListingType('facilities')
      allFacilities = _.cloneDeep(allFacilities).filter(fac => {
        let facility = facinfo?.facilities?.find(f => f.facilityId == fac.facilityId)
        if (facility) {
          let hidden = facility.facilityControls && facility.facilityControls.schedulingRules && facility.facilityControls.schedulingRules.pxAppSettings && facility.facilityControls.schedulingRules.pxAppSettings.hideFacilityForNormalVisit;
          
          return hidden ? false : true;
        } else {
          return true;
        }
      })
    }
    let allPractitionersArray = allFacilities.map(facility => {
      let practitioners = facility.practitioners.map(pract => {
        pract.facilityId = facility.facilityId;
        return pract;
      });
      return _.cloneDeep(practitioners);
    });
    let allPractitioners = [].concat.apply([], allPractitionersArray);
    if (selectedSpeciality) {
      allPractitioners = allPractitioners.filter(pract => selectedSpeciality == pract.specialityId)
    }
    if (consultType?.length > 0) {
      allPractitioners = allPractitioners.filter(pract => consultType.includes(pract?.schedulerControls?.['consultType']))
    }
    if (getUniquePractitioners) {
      allPractitioners = allPractitioners.filter((pract, ind)=> ind == allPractitioners.findIndex(a=> a.resourceId == pract.resourceId))
    }
    allPractitioners.forEach(dr => {
      var allPractForAllFacility = [].concat.apply([], allPractitionersArray);
      var selectedPracts=allPractForAllFacility.filter(pract => pract.resourceId == dr.resourceId)
      dr['availFacilities']=selectedPracts.map(pract => pract.facilityId)
    })
    return _.cloneDeep(allPractitioners);
  }

    public computeCostForAppt(apptDetail, chargeDetail) {
    const discountDetails = apptDetail.selectedDiscountDetails
    const couponDetails = apptDetail.couponDetails
    console.log('computeCostForAppt', chargeDetail)
    let freeFollowup: 'Y' | 'N' = 'N';
    let paid: boolean = false;
    let charge: number = 0;
    let additionalChargeDetails: any = {};
    let billingGroupCode: string;
    let promoDetails: PromoDetails;
    if (chargeDetail['freeFollowUpYn'] == 'Y') {
      freeFollowup = chargeDetail['freeFollowUpYn']
    } else {
      if (chargeDetail && chargeDetail.discount && chargeDetail.discount.discountApplicable == 'Y') {
        promoDetails = {
          applicable: true,
          charge: chargeDetail['charge']
        }
      }
    }
    if (apptDetail['paymentStatus'] == 'PAID') {
      paid = true;
    }
    if (paid) {
      charge = apptDetail['paymentAmt'];
    } else {
      if (freeFollowup != 'Y') {
        charge = chargeDetail['patientPayableAmount'];
        additionalChargeDetails = {
          actualCharge: chargeDetail['actualAmount'],
          totalCharge: chargeDetail['totalAmount'],
          payableCharge: chargeDetail['patientPayableAmount']
        }
      }
    }
    if (apptDetail['paymentStatus'] == 'PAID') {
      paid = true;
    }
    if (chargeDetail['billingGroupCode']) {
      billingGroupCode = chargeDetail['billingGroupCode'];
    }
    let promoCodeParams = this.getpromoCodeParam(apptDetail)
    let vatAmount = chargeDetail?.parsedCharge?.vatAmount
    const calculated: any = {
      netPayable: charge,
      discountedPayable: charge
    }
    if (discountDetails?.appliedpromocodedtls?.length > 0 || discountDetails?.pointsDerivative?.amount) {
      if (discountDetails?.appliedpromocodedtls?.length) {
        // Promo
        calculated.appliedpromocodedtls = discountDetails?.appliedpromocodedtls || null;
        calculated.promoDiscount = Number(discountDetails?.calculatedDiscountAmt || 0);
        calculated.isPromoApplied = discountDetails?.appliedpromocodedtls?.length > 0;
      } else if (discountDetails?.pointsDerivative?.amount) {
        // Points
        calculated.appliedPoints = discountDetails?.pointsDerivative || null;
        calculated.pointsDiscount = Number(discountDetails?.pointsDerivative?.amount || 0);
        calculated.isPointsApplied = calculated.pointsDiscount > 0
      }
      //Discount
      let discount = calculated.promoDiscount || calculated.pointsDiscount || 0
      calculated.discountedCC = Number(chargeDetail?.parsedCharge?.baseServiceAmount) - discount
      calculated.netPayable = Number(discountDetails?.netservicecharge)
      calculated.discountedPayable = Number(discountDetails?.netservicecharge)
      vatAmount = Number(discountDetails?.vatAmount)
    }
    // Coupon
    if (couponDetails?.appliedcouponcodedtls) {
      calculated.appliedcouponcodedtls = couponDetails.appliedcouponcodedtls;
      calculated.couponTitle = calculated.appliedcouponcodedtls.map(item => item.couponTitle)
      calculated.couponDiscount = Number(couponDetails.value);
      calculated.isCouponApplied = couponDetails.appliedcouponcodedtls.length > 0;
      let couponDiscount = calculated.couponDiscount || 0;
      calculated.netPayable = calculated?.discountedPayable - couponDiscount;
    }

    if (paid) {
      let couponInfo = apptDetail?.additionalApptDetails?.couponInfo
      if (couponInfo?.pointsAmount) {
        calculated.pointsDiscount = Number(couponInfo?.pointsAmount)
      }
      if (couponInfo?.couponAmtBurnt?.length) {
        calculated.couponDiscount = couponInfo?.couponAmtBurnt.reduce((r, a) => {
          r += Number(a || 0);
          return r
        }, 0)
      }
      let promoDtls = apptDetail?.additionalApptDetails?.promo_dtls
      if (promoDtls?.length) {
        calculated.promoDiscount = promoDtls.reduce((r, a) => {
          r += Number(a?.calculatedDiscountAmt || 0);
          return r
        }, 0)
      }
    }

    let computed: any = {
      loading: false,
      //charge always equals patientPayable
      charge: calculated.netPayable,
      patientPayable: calculated.netPayable,
      //charge always equals patientPayable
      discountedPayable: calculated?.discountedPayable,
      freeFollowUp: freeFollowup,
      billingGroupCode: billingGroupCode,
      paid: paid,
      additionalChargeDetails: additionalChargeDetails,
      promoDetails: promoDetails,
      promoCodeParams: promoCodeParams,
      chargeVatDetails: chargeDetail?.parsedCharge,
      coupon_or_discount: calculated,
      isPromoApplied: calculated.isPromoApplied,
      isPointsApplied: calculated.isPointsApplied,
      isCouponApplied: calculated.isCouponApplied,
      display: {
        cc: chargeDetail?.parsedCharge?.baseServiceAmount,
        vat: chargeDetail?.parsedCharge?.vatExemptedYN === 'Y' ? 0 : vatAmount,
        promo: calculated.promoDiscount || 0,
        points: calculated.pointsDiscount || 0,
        coupon: calculated.couponDiscount || 0,
        discountedCC: calculated.discountedCC,
        discountApplied: (calculated.promoDiscount || calculated.pointsDiscount)  ? 'Y':  'N',
        discountedPayable: Number(calculated.discountedPayable),
        payable: calculated.netPayable
      },
      missedInsuranceEntryKey:chargeDetail.missedInsuranceEntryKey
    }

    return computed;
  }

  getpromoCodeParam(apptDetail) {
    let speciality = this.getSpecialityByPractId(apptDetail.practitionerId, apptDetail.facilityId);
    return {
      selectedSpeciality: speciality && speciality['specialityId'] ? speciality['specialityId'] : null,
      selectedPractitioner: apptDetail.practitionerId,
      selectedFacility: {
        facilityId: apptDetail.facilityId,
      },
      selectedPatient: {
        patientId: apptDetail.patientId
      }
    }
  }
}

export function PasswordValidator(pattern: string, minLength, maxLength): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let errors: any = {}
    if (minLength) {
      if (control.value.length < minLength) {
        errors['minlength'] = { count: minLength }
      }
      if (control.value.length > maxLength) {
        errors['maxlength'] = { count: maxLength }
      }
    }
    let reg = new RegExp(pattern);
    const patternError = reg.test(control.value);
    if (!patternError) {
      errors['pattern'] = { pattern: patternError }
    }
    // console.log('PasswordValidator', errors)
    return Object.keys(errors).length ? errors : null
  };
  
}
